/** @flow */

// Changset Approvables

export const FetchApprovableChangeSchemas = "FETCH_APPROVABLE_CHANGE_SCHEMAS";
export const SetApprovableChangeSchemas = "SET_APPROVABLE_CHANGE_SCHEMAS";
export const BlockApprovableChange = "BLOCK_APPROVABLE_CHANGE";
export const BlockApprovableChangeSuccess = "BLOCK_APPROVABLE_CHANGE_SUCCESS";
export const BlockApprovableChangeError = "BLOCK_APPROVABLE_CHANGE_ERROR";
export const DeferApprovableChange = "DEFER_APPROVABLE_CHANGE";
export const DeferApprovableChangeSuccess = "DEFER_APPROVABLE_CHANGE_SUCCESS";
export const DeferApprovableChangeError = "DEFER_APPROVABLE_CHANGE_ERROR";
export const ApproveApprovableChange = "APPROVE_APPROVABLE_CHANGE";
export const ApproveApprovableChangeSuccess = "APPROVE_APPROVABLE_CHANGE_SUCCESS";
export const ApproveApprovableChangeError = "APPROVE_APPROVABLE_CHANGE_ERROR";
export const ToggleBlockApprovableChangeModal = "TOGGLE_BLOCK_APPROVABLE_CHANGE_MODAL";
export const ToggleDeferApprovableChangeModal = "TOGGLE_DEFER_APPROVABLE_CHANGE_MODAL";
export const ToggleApproveApprovableChangeModal = "TOGGLE_APPROVE_APPROVABLE_CHANGE_MODAL";

// Service Settings

export const GetServiceSettings = "GET_SERVICE_SETTINGS";
export const GetServiceSettingsSuccess = "GET_SERVICE_SETTINGS_SUCCESS";
export const GetServiceSettingsError = "GET_SERVICE_SETTINGS_ERROR";
export const UpdateServiceSettings = "UPDATE_SERVICE_SETTINGS";
export const UpdateServiceSettingsSuccess = "UPDATE_SERVICE_SETTINGS_SUCCESS";
export const UpdateServiceSettingsError = "UPDATE_SERVICE_SETTINGS_ERROR";
export const SubmitServiceSettings = "SUBMIT_SERVICE_SETTINGS";
export const SubmitServiceSettingsSuccess = "SUBMIT_SERVICE_SETTINGS_SUCCESS";
export const SubmitServiceSettingsError = "SUBMIT_SERVICE_SETTINGS_ERROR";

export const GetServiceSettingsSchema = "GET_SERVICE_SETTINGS_SCHEMA";
export const GetServiceSettingsSchemaSuccess = "GET_SERVICE_SETTINGS_SCHEMA_SUCCESS";
export const GetServiceSettingsSchemaError = "GET_SERVICE_SETTINGS_SCHEMA_ERROR";

export const SetEditedServiceSettings = "SET_EDITED_SERVICE_SETTINGS";
export const ClearEditedServiceSettings = "CLEAR_EDITED_SERVICE_SETTINGS";
export const SetShowEditServiceSettingsModal = "SET_SHOW_EDIT_SERVICE_SETTINGS_MODAL";
export const SetShowSubmitServiceSettingsModal = "SET_SHOW_SUBMIT_SERVICE_SETTINGS_MODAL";

// Email Notifications

export const GetEmailNotifications = "GET_EMAIL_NOTIFICATIONS";
export const GetEmailNotificationsSuccess = "GET_EMAIL_NOTIFICATIONS_SUCCESS";
export const GetEmailNotificationsError = "GET_EMAIL_NOTIFICATIONS_ERROR";
export const GetEmailNotification = "GET_EMAIL_NOTIFICATION";
export const GetEmailNotificationSuccess = "GET_EMAIL_NOTIFICATION_SUCCESS";
export const GetEmailNotificationError = "GET_EMAIL_NOTIFICATION_ERROR";
export const GetEmailNotificationAssignments = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS";
export const GetEmailNotificationAssignmentsSuccess = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS_SUCCESS";
export const GetEmailNotificationAssignmentsError = "GET_EMAIL_NOTIFICATION_ASSIGNMENTS_ERROR";

export const AddEmailNotification = "ADD_EMAIL_NOTIFICATION";
export const AddEmailNotificationSuccess = "ADD_EMAIL_NOTIFICATION_SUCCESS";
export const AddEmailNotificationError = "ADD_EMAIL_NOTIFICATION_ERROR";
export const UpdateEmailNotification = "UPDATE_EMAIL_NOTIFICATION";
export const UpdateEmailNotificationSuccess = "UPDATE_EMAIL_NOTIFICATION_SUCCESS";
export const UpdateEmailNotificationError = "UPDATE_EMAIL_NOTIFICATION_ERROR";
export const DeleteEmailNotification = "DELETE_EMAIL_NOTIFICATION";
export const DeleteEmailNotificationSuccess = "DELETE_EMAIL_NOTIFICATION_SUCCESS";
export const DeleteEmailNotificationError = "DELETE_EMAIL_NOTIFICATION_ERROR";

export const GetEmailNotificationSchema = "GET_EMAIL_NOTIFICATION_SCHEMA";
export const GetEmailNotificationSchemaSuccess = "GET_EMAIL_NOTIFICATION_SCHEMA_SUCCESS";
export const GetEmailNotificationSchemaError = "GET_EMAIL_NOTIFICATION_SCHEMA_ERROR";

export const SetCurrentEmailNotification = "SET_CURRENT_EMAIL_NOITIFICATION";
export const SetEditedEmailNotification = "SET_EDITED_EMAIL_NOTIFICATION";
export const SetEmailNotificationAssignments = "SET_EMAIL_NOTIFICATION_ASSIGNMENTTS";

export const SetShowAddEmailNotificationModal = "SET_SHOW_ADD_EMAIL_NOTIFICATION_MODAL";
export const SetShowEditEmailNotificationModal = "SET_SHOW_EDIT_EMAIL_NOTIFICATION_MODAL";
export const SetShowDeleteEmailNotificationModal = "SET_SHOW_DELETE_EMAIL_NOTIFICATION_MODAL";

// Manager Sms Settings

export const GetManagerSmsNotificationSettings = "GET_MANAGER_SMS_NOTIFICATION_SETTINGS";
export const GetManagerSmsNotificationSettingsSuccess =
  "GET_MANAGER_SMS_NOTIFICATION_SETTINGS_SUCCESS";
export const GetManagerSmsNotificationSettingsError = "GET_MANAGER_SMS_NOTIFICATION_SETTINGS_ERROR";
export const UpdateManagerSmsNotificationSettings = "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS";
export const UpdateManagerSmsNotificationSettingsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS_SUCCESS";
export const UpdateManagerSmsNotificationSettingsError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SETTINGS_ERROR";

export const SetManagerSmsNotificationCurrent = "SET_MANAGER_SMS_NOTIFICATION_CURRENT";
export const SetManagerSmsNotificationAssignments = "SET_MANAGER_SMS_NOTIFICATION_ASSIGNMENTS";

export const SetShowAddManagerSmsNotificationModal = "SHOW_ADD_MANAGER_SMS_NOTIFICATION_MODAL";
export const SetShowEditManagerSmsNotificationModal = "SHOW_EDIT_MANAGER_SMS_NOTIFICATION_MODAL";
export const SetShowDeleteManagerSmsNotificationModal =
  "SHOW_DELETE_MANAGER_SMS_NOTIFICATION_MODAL";

// Manager Sms Notifications SMS

export const GetManagerSmsNotificationsSmsRules = "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES";
export const GetManagerSmsNotificationsSmsRulesSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES_SUCCESS";
export const GetManagerSmsNotificationsSmsRulesError =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_RULES_ERROR";

export const GetManagerSmsNotificationsSmsAssignments =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS";
export const GetManagerSmsNotificationsSmsAssignmentsSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_SUCCESS";
export const GetManagerSmsNotificationsSmsAssignmentsError =
  "GET_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_ERROR";
export const UpdateManagerSmsNotificationsSmsAssignments =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS";
export const UpdateManagerSmsNotificationsSmsAssignmentsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_SUCCESS";
export const UpdateManagerSmsNotificationsSmsAssignmentsError =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_SMS_ASSIGNMENTS_ERROR";

export const AddManagerSmsNotificationSmsRule = "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const AddManagerSmsNotificationSmsRuleSuccess =
  "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const AddManagerSmsNotificationSmsRuleError = "ADD_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";
export const UpdateManagerSmsNotificationSmsRule = "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const UpdateManagerSmsNotificationSmsRuleSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const UpdateManagerSmsNotificationSmsRuleError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";
export const DeleteManagerSmsNotificationSmsRule = "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE";
export const DeleteManagerSmsNotificationSmsRuleSuccess =
  "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE_SUCCESS";
export const DeleteManagerSmsNotificationSmsRuleError =
  "DELETE_MANAGER_SMS_NOTIFICATION_SMS_RULE_ERROR";

// Manager Sms Notifications PAGER

export const GetManagerSmsNotificationsPagerRules = "GET_MANAGER_SMS_NOTIFICATIONS_PAGER";
export const GetManagerSmsNotificationsPagerRulesSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_SUCCESS";
export const GetManagerSmsNotificationsPagerRulesError =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ERROR";

export const GetManagerSmsNotificationsPagerAssignments =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS";
export const GetManagerSmsNotificationsPagerAssignmentsSuccess =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_SUCCESS";
export const GetManagerSmsNotificationsPagerAssignmentsError =
  "GET_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_ERROR";
export const UpdateManagerSmsNotificationsPagerAssignments =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS";
export const UpdateManagerSmsNotificationsPagerAssignmentsSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_SUCCESS";
export const UpdateManagerSmsNotificationsPagerAssignmentsError =
  "UPDATE_MANAGER_SMS_NOTIFICATIONS_PAGER_ASSIGNMENTS_ERROR";

export const AddManagerSmsNotificationPagerRule = "ADD_MANAGER_SMS_NOTIFICATION_PAGER";
export const AddManagerSmsNotificationPagerRuleSuccess =
  "ADD_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const AddManagerSmsNotificationPagerRuleError = "ADD_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";
export const UpdateManagerSmsNotificationPagerRule = "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER";
export const UpdateManagerSmsNotificationPagerRuleSuccess =
  "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const UpdateManagerSmsNotificationPagerRuleError =
  "UPDATE_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";
export const DeleteManagerSmsNotificationPagerRule = "DELETE_MANAGER_SMS_NOTIFICATION_PAGER";
export const DeleteManagerSmsNotificationPagerRuleSuccess =
  "DELETE_MANAGER_SMS_NOTIFICATION_PAGER_SUCCESS";
export const DeleteManagerSmsNotificationPagerRuleError =
  "DELETE_MANAGER_SMS_NOTIFICATION_PAGER_ERROR";

// Employee Sms Notifications

export const GetEmployeeSmsSettings = "GET_EMPLOYEE_SMS_SETTINGS";
export const GetEmployeeSmsSettingsSuccess = "GET_EMPLOYEE_SMS_SETTINGS_SUCCESS";
export const GetEmployeeSmsSettingsError = "GET_EMPLOYEE_SMS_SETTINGS_ERROR";
export const UpdateEmployeeSmsSettings = "UPDATE_EMPLOYEE_SMS_SETTINGS";
export const UpdateEmployeeSmsSettingsSuccess = "UPDATE_EMPLOYEE_SMS_SETTINGS_SUCCESS";
export const UpdateEmployeeSmsSettingsError = "UPDATE_EMPLOYEE_SMS_SETTINGS_ERROR";

export const GetEmployeeSmsRules = "GET_EMPLOYEE_SMS_RULES";
export const GetEmployeeSmsRulesSuccess = "GET_EMPLOYEE_SMS_RULES_SUCCESS";
export const GetEmployeeSmsRulesError = "GET_EMPLOYEE_SMS_RULES_ERROR";
export const AddEmployeeSmsRule = "ADD_EMPLOYEE_SMS_RULE";
export const AddEmployeeSmsRuleSuccess = "ADD_EMPLOYEE_SMS_RULE_SUCCESS";
export const AddEmployeeSmsRuleError = "ADD_EMPLOYEE_SMS_RULE_ERROR";
export const UpdateEmployeeSmsRule = "UPDATE_EMPLOYEE_SMS_RULE";
export const UpdateEmployeeSmsRuleSuccess = "UPDATE_EMPLOYEE_SMS_RULE_SUCCESS";
export const UpdateEmployeeSmsRuleError = "UPDATE_EMPLOYEE_SMS_RULE_ERROR";
export const DeleteEmployeeSmsRule = "DELETE_EMPLOYEE_SMS_RULE";
export const DeleteEmployeeSmsRuleSuccess = "DELETE_EMPLOYEE_SMS_RULE_SUCCESS";
export const DeleteEmployeeSmsRuleError = "DELETE_EMPLOYEE_SMS_RULE_ERROR";
export const GetEmployeeSmsAssignments = "GET_EMPLOYEE_SMS_ASSIGNMENTS";
export const GetEmployeeSmsAssignmentsSuccess = "GET_EMPLOYEE_SMS_ASSIGNMENTS_SUCCESS";
export const GetEmployeeSmsAssignmentsError = "GET_EMPLOYEE_SMS_ASSIGNMENTS_ERROR";

export const GetEmployeeSmsSchema = "GET_EMPLOYEE_SMS_SCHEMA";
export const GetEmployeeSmsSchemaSuccess = "GET_EMPLOYEE_SMS_SCHEMA_SUCCESS";
export const GetEmployeeSmsSchemaError = "GET_EMPLOYEE_SMS_SCHEMA_ERROR";
export const SetEmployeeSmsCurrent = "SET_EMPLOYEE_SMS_CURRENT";
export const SetEmployeeSmsAssignments = "SET_EMPLOYEE_SMS_ASSIGNMENTS";

export const SetShowAddEmployeeSmsModal = "SHOW_ADD_EMPLOYEE_SMS_MODAL";
export const SetShowEditEmployeeSmsModal = "SHOW_EDIT_EMPLOYEE_SMS_MODAL";
export const SetShowDeleteEmployeeSmsModal = "SHOW_DELETE_EMPLOYEE_SMS_MODAL";

// Shift Patterns
export const GetShiftPatterns = "GET_SHIFT_PATTERNS";
export const GetShiftPatternsSuccess = "GET_SHIFT_PATTERNS_SUCCESS";
export const GetShiftPatternsError = "GET_SHIFT_PATTERNS_ERROR";
export const GetTotalShiftPatterns = "GET_TOTAL_SHIFT_PATTERNS";
export const GetTotalShiftPatternsSuccess = "GET_TOTAL_SHIFT_PATTERNS_SUCCESS";
export const GetTotalShiftPatternsError = "GET_TOTAL_SHIFT_PATTERNS_ERROR";
export const NewShiftPattern = "NEW_SHIFT_PATTERN";
export const SetShiftPattern = "SET_SHIFT_PATTERN";
export const AddShiftPattern = "ADD_SHIFT_PATTERN";
export const AddShiftPatternSuccess = "ADD_SHIFT_PATTERN_SUCCESS";
export const AddShiftPatternError = "ADD_SHIFT_PATTERN_ERROR";
export const UpdateShiftPattern = "UPDATE_SHIFT_PATTERN";
export const UpdateShiftPatternSuccess = "UPDATE_SHIFT_PATTERN_SUCCESS";
export const UpdateShiftPatternError = "UPDATE_SHIFT_PATTERN_ERROR";
export const DeleteShiftPattern = "DELETE_SHIFT_PATTERN";
export const DeleteShiftPatternSuccess = "DELETE_SHIFT_PATTERN_SUCCESS";
export const DeleteShiftPatternError = "DELETE_SHIFT_PATTERN_ERROR";
export const ShowAddShiftPatternModal = "SHOW_ADD_SHIFT_PATTERN_MODAL";
export const ShowEditShiftPatternModal = "SHOW_EDIT_SHIFT_PATTERN_MODAL";
export const ShowDeleteShiftPatternModal = "SHOW_DELETE_SHIFT_PATTERN_MODAL";
export const UpdateShiftPatternDraft = "UPDATE_SHIFT_PATTERN_DRAFT";
export const ToggleUnassignReassignShiftPatternModal =
  "TOGGLE_UNASSIGN_REASSIGN_SHIFT_PATTERN_MODAL";
export const GetEmployeePositionsAssignedToShiftPattern =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN";
export const GetEmployeePositionsAssignedToShiftPatternSuccess =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN_SUCCESS";
export const GetEmployeePositionsAssignedToShiftPatternError =
  "GET_EMPLOYEE_POSITIONS_ASSIGNED_TO_SHIFT_PATTERN_ERROR";
export const ToggleUnassignReassignItemsToShiftPatternModal =
  "TOGGLE_UNASSIGN_REASSIGN_ITEMS_TO_SHIFT_PATTERN_MODAL";
export const UnassignReassignItemsShiftPattern = "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN";
export const UnassignReassignItemsShiftPatternSuccess =
  "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN_SUCCESS";
export const UnassignReassignItemsShiftPatternError = "UNASSIGN_REASSIGN_ITEMS_SHIFT_PATTERN_ERROR";
export const GetDepartmentsAssignedToShiftPattern = "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN";
export const GetDepartmentsAssignedToShiftPatternSuccess =
  "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN_SUCCESS";
export const GetDepartmentsAssignedToShiftPatternError =
  "GET_DEPARTMENTS_ASSIGNED_TO_SHIFT_PATTERN_ERROR";

//Staff Groups
export const ToggleDisableStaffGroupModal = "TOGGLE_DISABLE_STAFF_GROOUP_MODAL";
export const UpdateStaffGroup = "UPDATE_STAFF_GROUP";
export const UpdateStaffGroupError = "UPDATE_STAFF_GROUP_ERROR";
export const ReassignStaffGroup = "REASSIGN_STAFF_GROUP";
export const EnableStaffGroup = "ENABLE_STAFF_GROUP";
export const EnableStaffGroupError = "ENABLE_STAFF_GROUP_ERROR";
export const GetStaffGroups = "GET_STAFF_GROUPS";
export const ToggleReassignStaffGroupModal = "TOGGLE_REASSIGN_STAFF_GROUP_MODAL";
export const GetStaffGroupsSuccess = "GET_STAFF_GROUPS_SUCCESS";
export const GetStaffGroupsError = "GET_STAFF_GROUPS_ERROR";
export const SetStaffGroupSchema = "SET_STAFF_GROUP_SCHEMA";
export const GetTotalStaffGroups = "GET_TOTAL_STUFF_GROUPS";
export const GetTotalStaffGroupsSuccess = "GET_TOTAL_STUFF_GROUPS_SUCCESS";
export const GetTotalStaffGroupsError = "GET_TOTAL_STUFF_GROUPS_ERROR";
export const ToggleAddStaffGroupModal = "TOGGLE_ADD_STAFF_GROUP_MODAL";
export const AddStaffGroup = "ADD_STAFF GROUP";
export const GetAddStaffGroupError = "GET_ADD_STAFF_GROUP_ERROR";
export const ToggleEditStaffGroupModal = "TOGGLE_EDIT_STAFF_GROUP_MODAL";
export const EditStaffGroup = "EDIT_STAFF_GROUP";
export const GetStaffGroupsSchema = "GET_STAFF_GROUPS_SCHEMA";
export const SetStaffGroupsSchema = "SET_STAFF_GROUPS_SCHEMA";
export const SaveStaffGroupConfiguration = "SAVE_STAFF_GROUP_CONFIGURATION";
export const GetStaffGroupsConfiguration = "GET_STAFF_GROUPS_CONFIGURATION";
export const GetStaffGroupsConfigurationSuccess = "GET_STAFF_GROUPS_CONFIGURATION_SUCCESS";
export const ToggleEnableStaffGroupModal = "TOGGLE_ENABLE_STAFF_GROUP_MODAL";
export const SetStaffGroupsSort = "SET_STAFF_GROUPS_SORT";
export const ShowReassignStaffGroupModal = "SHOW_REASSIGN_STAFF_GROUP_MODAL";

export const DismissAddNurseDeclinedReason = "DISMISS_ADD_NURSE_DECLINED_REASON";
export const ToggleAddShiftModal = "TOGGLE_ADD_SHIFT_MODAL";
export const ToggleUpdateShiftModal = "TOGGLE_UPDATE_SHIFT_MODAL";
export const GetDataSecuritySettings = "GET_DATA_SECURITY_SETTINGS";
export const GetDataSecuritySettingsSuccess = "GET_DATA_SECURITY_SETTINGS_SUCCESS";
export const GetDataSecuritySettingsError = "GET_DATA_SECURITY_SETTINGS_ERROR";
export const UpdateDataSecuritySettings = "UPDATE_DATA_SECURITY_SETTINGS";
export const UpdateDataSecuritySettingsSuccess = "UPDATE_DATA_SECURITY_SETTINGS_SUCCESS";
export const UpdateDataSecuritySettingsError = "UPDATE_DATA_SECURITY_SETTINGS_ERROR";
export const GetEmployeeSchemaSuccess = "GET_EMPLOYEE_SCHEMA_SUCCESS";
export const GetEmployeeSchemaError = "GET_EMPLOYEE_SCHEMA_ERROR";
export const GetEmployeeSecuritySchema = "GET_EMPLOYEE_SECURITY_SCHEMA";
export const GetEmployeeSecuritySchemaSuccess = "GET_EMPLOYEE_SECURITY_SCHEMA_SUCCESS";
export const GetEmployeeSecuritySchemaError = "GET_EMPLOYEE_SECURITY_SCHEMA_ERROR";

// System Access
export const GetDataSecurityGeneralSettings = "GET_DATA_SECURITY_GENERAL_SETTINGS";
export const GetDataSecurityGeneralSettingsSuccess = "GET_DATA_SECURITY_GENERAL_SETTINGS_SUCCESS";
export const GetDataSecurityGeneralSettingsError = "GET_DATA_SECURITY_GENERAL_SETTINGS_ERROR";
export const ToggleSystemAccessPasswordResetModal = "TOGGLE_SYSTEM_ACCESS_PASSWORD_RESET_MODAL";
export const ToggleSystemAccessLogOutLockModal = "TOGGLE_SYSTEM_ACCESS_LOG_OUT_LOCK_MODAL";
export const ToggleAddIpRestrictionModal = "TOGGLE_ADD_IP_RESTRICTION_MODAL";
export const UpdateDataSecurityGeneralSettings = "UPDATE_DATA_SECURITY_GENERAL_SETTINGS";
export const UpdateDataSecurityGeneralSettingsSuccess =
  "UPDATE_DATA_SECURITY_GENERAL_SETTINGS_SUCCESS";
export const UpdateDataSecurityGeneralSettingsError = "UPDATE_DATA_SECURITY_GENERAL_SETTINGS_ERROR";
export const GetClientLogo = "GET_CLIENT_LOGO";
export const GetClientLogoSuccess = "GET_CLIENT_LOGO_SUCCESS";
export const GetClientLogoError = "GET_CLIENT_LOGO_ERROR";
export const UploadClientLogo = "UPLOAD_CLIENT_LOGO";
export const UploadClientLogoSuccess = "UPLOAD_CLIENT_LOGO_SUCCESS";
export const UploadClientLogoError = "UPLOAD_CLIENT_LOGO_ERROR";
export const ToggleClientLogoModal = "TOGGLE_CLIENT_LOGO_MODAL";
export const ToggleRegistrationEmailsModal = "TOGGLE_REGISTRATION_EMAILS_MODAL";
export const ToggleEmployeeRegistrationEmailsModal = "TOGGLE_EMPLOYEE_REGISTRATION_EMAILS_MODAL";
export const ToggleRegistrationEmailsExportModal = "TOGGLE_REGISTRATION_EMAILS_EXPORT_MODAL";
export const SendBulkRegistrationEmails = "SEND_BULK_REGISTRATION_EMAILS";
export const SendBulkRegistrationEmailsSuccess = "SEND_BULK_REGISTRATION_EMAILS_SUCCESS";
export const SendBulkRegistrationEmailsError = "SEND_BULK_REGISTRATION_EMAILS_ERROR";
export const SendEmployeeRegistrationEmails = "SEND_EMPLOYEE_REGISTRATION_EMAILS";
export const SendEmployeeRegistrationEmailsSuccess = "SEND_EMPLOYEE_REGISTRATION_EMAILS_SUCCESS";
export const SendEmployeeRegistrationEmailsError = "SEND_EMPLOYEE_REGISTRATION_EMAILS_ERROR";
export const GetBulkRegistrationEmails = "GET_BULK_REGISTRATION_EMAILS";
export const GetBulkRegistrationEmailsSuccess = "GET_BULK_REGISTRATION_EMAILS_SUCCESS";
export const GetBulkRegistrationEmailsError = "GET_BULK_REGISTRATION_EMAILS_ERROR";
export const GetBulkRegistrationEmailsTargets = "GET_BULK_REGISTRATION_EMAILS_TARGETS";
export const GetBulkRegistrationEmailsTargetsSuccess =
  "GET_BULK_REGISTRATION_EMAILS_TARGETS_SUCCESS";
export const GetBulkRegistrationEmailsTargetsError = "GET_BULK_REGISTRATION_EMAILS_TARGETS_ERROR";
export const GetEmployeeRegistrationEmailsTargets = "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS";
export const GetEmployeeRegistrationEmailsTargetsSuccess =
  "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS_SUCCESS";
export const GetEmployeeRegistrationEmailsTargetsError =
  "GET_EMPLOYEE_REGISTRATION_EMAILS_TARGETS_ERROR";
export const GetPlatformDataSecurity = "GET_PLATFORM_DATA_SECURITY";
export const GetPlatformDataSecuritySuccess = "GET_PLATFORM_DATA_SECURITY_SUCCESS";
export const GetPlatformDataSecurityError = "GET_PLATFORM_DATA_SECURITY_ERROR";
export const ToggleStandardRegistrationEmailsModal = "TOGGLE_STANDARD_REGISTRATION_EMAILS_MODAL";
export const UpdateRegistrationEmails = "UPDATE_REGISTRATION_EMAILS";
export const UpdateRegistrationEmailsSuccess = "UPDATE_REGISTRATION_EMAILS_SUCCESS";
export const UpdateRegistrationEmailsError = "UPDATE_REGISTRATION_EMAILS_ERROR";
export const ExportBulkRegistrationEmails = "EXPORT_BULK_REGISTRATION_EMAILS";
export const ExportBulkRegistrationEmailsSuccess = "EXPORT_BULK_REGISTRATION_EMAILS_SUCCESS";
export const ExportBulkRegistrationEmailsError = "EXPORT_BULK_REGISTRATION_EMAILS_ERROR";

// Email Controls
export const GetEmailControlsSettings = "GET_EMAIL_CONTROLS_SETTINGS";
export const GetEmailControlsSettingsSuccess = "GET_EMAIL_CONTROLS_SETTINGS_SUCCESS";
export const GetEmailControlsSettingsError = "GET_EMAIL_CONTROLS_SETTINGS_ERROR";
export const UpdateEmailControlsSettings = "UPDATE_EMAIL_CONTROLS_SETTINGS";
export const UpdateEmailControlsSettingsSuccess = "UPDATE_EMAIL_CONTROLS_SETTINGS_SUCCESS";
export const UpdateEmailControlsSettingsError = "UPDATE_EMAIL_CONTROLS_SETTINGS_ERROR";
export const ToggleEmailContentSettingsModal = "TOGGLE_EMAIL_CONTENT_SETTINGS_MODAL";
export const ToggleAddEmailDomainModal = "TOGGLE_ADD_EMAIL_DOMAIN_MODAL";
export const SetEditedEmailContentSettingsModal = "SET_EDITED_EMAIL_CONTENT_SETTINGS_MODAL";

// Nurse Declined Reasons
export const GetNurseDeclinedReasonsList = "GET_NURSE_DECLINED_REASONS_LIST";
export const GetNurseDeclinedReasonsListSuccess = "GET_NURSE_DECLINED_REASON_LISTS_SUCCESS";
export const GetNurseDeclinedReasonsListError = "GET_NURSE_DECLINED_REASON_LISTS_ERROR";
export const GetNurseDeclinedReason = "GET_NURSE_DECLINED_REASON";
export const GetNurseDeclinedReasonSuccess = "GET_NURSE_DECLINED_REASON_SUCCESS";
export const GetNurseDeclinedReasonError = "GET_NURSE_DECLINED_REASON_ERROR";
export const GetNurseDeclinedReasonSchema = "GET_NURSE_DECLINED_REASON_SCHEMA";
export const GetNurseDeclinedReasonSchemaSuccess = "GET_NURSE_DECLINED_REASON_SCHEMA_SUCCESS";
export const GetNurseDeclinedReasonSchemaError = "GET_NURSE_DECLINED_REASON_SCHEMA_ERROR";

export const NewNurseDeclinedReason = "NEW_NURSE_DECLINED_REASON";
export const StartDraftNurseDeclinedReason = "START_NURSE_DECLINED_REASON_DRAFT";
export const StartDraftNurseDeclinedReasonSuccess = "START_NURSE_DECLINED_REASON_DRAFT_SUCCESS";
export const StartDraftNurseDeclinedReasonError = "START_NURSE_DECLINED_REASON_DRAFT_ERROR";
export const DuplicateNurseDeclinedReason = "DUPLICATE_NURSE_DECLINED_REASON";
export const DuplicateNurseDeclinedReasonSuccess = "DUPLICATE_NURSE_DECLINED_REASON)_SUCCESS";
export const DuplicateNurseDeclinedReasonError = "DUPLICATE_NURSE_DECLINED_REASON_ERROR";
export const SetNurseDeclinedReasonDraft = "UPDATE_NURSE_DECLINED_REASON_DRAFT";

export const AddNurseDeclinedReason = "ADD_NURSE_DECLINED_REASON";
export const AddNurseDeclinedReasonSuccess = "ADD_NURSE_DECLINED_REASON_SUCCESS";
export const AddNurseDeclinedReasonError = "ADD_NURSE_DECLINED_REASON_ERROR";
export const UpdateNurseDeclinedReason = "UPDATE_NURSE_DECLINED_REASON";
export const UpdateNurseDeclinedReasonSuccess = "UPDATE_NURSE_DECLINED_REASON_SUCCESS";
export const UpdateNurseDeclinedReasonError = "UPDATE_NURSE_DECLINED_REASON_ERROR";

export const DiscardNurseDeclinedReasonDraft = "DISCARD_NURSE_DECLINED_REASON_DRAFT";
export const DiscardNurseDeclinedReasonDraftSuccess = "DISCARD_NURSE_DECLINED_REASON_DRAFT_SUCCESS";
export const DiscardNurseDeclinedReasonDraftError = "DISCARD_NURSE_DECLINED_REASON_DRAFT_ERROR";
export const SubmitNurseDeclinedReasonForReview = "SUBMIT_NURSE_DECLINED_REASON_FOR_REVIEW";
export const SubmitNurseDeclinedReasonForReviewSuccess =
  "SUBMIT_NURSE_DECLINED_REASON_FOR_REVIEW_SUCCESS";
export const SubmitNurseDeclinedReasonForReviewError =
  "SUBMIT_NURSE_DECLINED_REASON_FOR_REVIEW_ERROR";
export const CancelNurseDeclinedReasonReview = "CANCEL_NURSE_DECLINED_REASON_REVIEW";
export const CancelNurseDeclinedReasonReviewSuccess = "CANCEL_NURSE_DECLINED_REASON_REVIEW_SUCCESS";
export const CancelNurseDeclinedReasonReviewError = "CANCEL_NURSE_DECLINED_REASON_REVIEW_ERROR";
export const CancelNurseDeclinedReasonReviewAndDiscard =
  "CANCEL_NURSE_DECLINED_REASON_REVIEW_AND_DISCARD_REVIEW";
export const CancelNurseDeclinedReasonReviewAndDiscardSuccess =
  "CANCEL_NURSE_DECLINED_REASON_REVIEW_AND_DISCARD_SUCCESS";
export const CancelNurseDeclinedReasonReviewAndDiscardError =
  "CANCEL_NURSE_DECLINED_REASON_REVIEW_AND_DISCARD_ERROR";
export const DisableNurseDeclinedReason = "DISABLE_NURSE_DECLINED_REASON";
export const DisableNurseDeclinedReasonSuccess = "DISABLE_NURSE_DECLINED_REASON_SUCCESS";
export const DisableNurseDeclinedReasonError = "DISABLE_NURSE_DECLINED_REASON_ERROR";

export const SetNurseDeclinedReasonsEnabled = "SET_SHOW_NURSE_DECLINED_REASONS_ENABLED";
export const SetNurseDeclinedReasonsStatus = "SET_SHOW_NURSE_DECLINED_REASONS_STATUS";
export const SetShowAddNurseDeclinedReasonModal = "SET_SHOW_NURSE_DECLINED_REASON_ADD_MODAL";
export const SetShowEditNurseDeclinedReasonModal = "SET_SHOW_NURSE_DECLINED_REASON_EDIT_MODAL";
export const SetShowDiscardNurseDeclinedReasonModal =
  "SET_SHOW_NURSE_DECLINED_REASON_SHOW_DISCARD_MODAL";
export const SetShowSubmitNurseDeclinedReasonModal =
  "SET_SHOW_NURSE_DECLINED_REASON_SHOW_SUBMIT_MODAL";
export const SetShowCancelNurseDeclinedReasonModal =
  "SET_SHOW_NURSE_DECLINED_REASON_SHOW_CANCEL_MODAL";
export const SetShowCancelDiscardNurseDeclinedReasonModal =
  "SET_SHOW_NURSE_DECLINED_REASON_SHOW_CANCEL_DISCARD_MODAL";
export const SetShowDisableNurseDeclinedReasonModal =
  "SET_SHOW_NURSE_DECLINED_REASON_SHOW_DISABLE_MODAL";

// EAP Signposting
export const GetEapList = "GET_EAP_LIST";
export const GetEapListSuccess = "GET_EAP_LIST_SUCCESS";
export const GetEapListError = "GET_EAP_LIST_ERROR";
export const GetEap = "GET_EAP";
export const GetEapSuccess = "GET_EAP_SUCCESS";
export const GetEapError = "GET_EAP_ERROR";
export const GetEapSchema = "GET_EAP_SCHEMA";
export const GetEapSchemaSuccess = "GET_EAP_SCHEMA_SUCCESS";
export const GetEapSchemaError = "GET_EAP_SCHEMA_ERROR";

export const DiscardEapDraft = "DISCARD_EAP_DRAFT";
export const DiscardEapDraftSuccess = "DISCARD_EAP_DRAFT_SUCCESS";
export const DiscardEapDraftError = "DISCARD_EAP_DRAFT_ERROR";
export const SubmitEapForReview = "SUBMIT_EAP_FOR_REVIEW";
export const SubmitEapForReviewSuccess = "SUBMIT_EAP_FOR_REVIEW_SUCCESS";
export const SubmitEapForReviewError = "SUBMIT_EAP_FOR_REVIEW_ERROR";
export const CancelEapReview = "CANCEL_EAP_REVIEW";
export const CancelEapReviewSuccess = "CANCEL_EAP_REVIEW_SUCCESS";
export const CancelEapReviewError = "CANCEL_EAP_REVIEW_ERROR";
export const CancelEapReviewAndDiscard = "CANCEL_EAP_REVIEW_AND_DISCARD_REVIEW";
export const CancelEapReviewAndDiscardSuccess = "CANCEL_EAP_REVIEW_AND_DISCARD_SUCCESS";
export const CancelEapReviewAndDiscardError = "CANCEL_EAP_REVIEW_AND_DISCARD_ERROR";
export const DisableEap = "DISABLE_EAP";
export const DisableEapSuccess = "DISABLE_EAP_SUCCESS";
export const DisableEapError = "DISABLE_EAP_ERROR";

export const NewEap = "NEW_EAP";
export const StartDraftEap = "START_EAP_DRAFT";
export const StartDraftEapSuccess = "START_EAP_DRAFT_SUCCESS";
export const StartDraftEapError = "START_EAP_DRAFT_ERROR";
export const DuplicateEap = "DUPLICATE_EAP";
export const DuplicateEapSuccess = "DUPLICATE_EAP_SUCCESS";
export const DuplicateEapError = "DUPLICATE_EAP_ERROR";
export const SetEapDraft = "SET_EAP_DRAFT";
export const NewEapAssignments = "NEW_EAP_ASSIGNMENTS";
export const SetEapAssignments = "SET_EAP_ASSIGNMENTS";
export const SetEapDraftAssignments = "SET_EAP_DRAFT_ASSIGNMENTS";

export const AddEap = "ADD_EAP";
export const AddEapSuccess = "ADD_EAP_SUCCESS";
export const AddEapError = "ADD_EAP_ERROR";
export const UpdateEap = "UPDATE_EAP";
export const UpdateEapSuccess = "UPDATE_EAP_SUCCESS";
export const UpdateEapError = "UPDATE_EAP_ERROR";
export const UpdateEapAssignments = "UPDATE_EAP_ASSIGNMENTS";
export const UpdateEapAssignmentsSuccess = "UPDATE_EAP_ASSIGNMENTS_SUCCESS";
export const UpdateEapAssignmentsError = "UPDATE_EAP_ASSIGNMENTS_ERROR";
export const SetEapEnabled = "SET_EAP_ENABLED";
export const SetEapStatus = "SET_EAP_STATUS";

export const ShowAddModal = "SHOW_EAP_ADD_MODAL";
export const ShowEditModal = "SHOW_EAP_EDIT_MODAL";
export const ShowEditAssignmentsModal = "SHOW_EDIT_ASSIGNMENTS_MODAL";
export const SetShowDiscardEapModal = "SET_EAP_SHOW_DISCARD_MODAL";
export const SetShowSubmitEapModal = "SET_EAP_SHOW_SUBMIT_MODAL";
export const SetShowCancelEapModal = "SET_EAP_SHOW_CANCEL_MODAL";
export const SetShowCancelDiscardEapModal = "SET_EAP_SHOW_CANCEL_DISCARD_MODAL";
export const SetShowDisableEapModal = "SET_EAP_SHOW_DISABLE_MODAL";

// Absence Reasons
export const GetAbsenceReasonsList = "GET_ABSENCE_REASONS_LIST";
export const GetAbsenceReasonsListSuccess = "GET_ABSENCE_REASONS_LIST_SUCCESS";
export const GetAbsenceReasonsListError = "GET_ABSENCE_REASONS_LIST_ERROR";
export const GetAbsenceReasonsActiveList = "GET_ABSENCE_REASONS_ACTIVE_LIST";
export const GetAbsenceReasonsActiveListSuccess = "GET_ABSENCE_REASONS_ACTIVE_LIST_SUCCESS";
export const GetAbsenceReasonsActiveListError = "GET_ABSENCE_REASONS_ACTIVE_LIST_ERROR";
export const GetAbsenceReasonsPendingList = "GET_ABSENCE_REASONS_PENDING_LIST";
export const GetAbsenceReasonsPendingListSuccess = "GET_ABSENCE_REASONS_PENDING_LIST_SUCCESS";
export const GetAbsenceReasonsPendingListError = "GET_ABSENCE_REASONS_PENDING_LIST_ERROR";
export const GetAbsenceReasonsDraftList = "GET_ABSENCE_REASONS_DRAFT_LIST";
export const GetAbsenceReasonsDraftListSuccess = "GET_ABSENCE_REASONS_DRAFT_LIST_SUCCESS";
export const GetAbsenceReasonsDraftListError = "GET_ABSENCE_REASONS_DRAFT_LIST_ERROR";
export const ShowAddAbsenceReasonModal = "SHOW_ADD_ABSENCE_REASON_MODAL";
export const NewAbsenceReason = "NEW_ABSENCE_REASON";
export const UpdateAbsenceReasonDraft = "UPDATE_ABSENCE_REASON_DRAFT";
export const SetAbsenceReasonRevisionSchema = "SET_ABSENCE_REASON_REVISION_SCHEMA";
export const GetAbsenceReasonActive = "GET_ABSENCE_REASON_ACTIVE";
export const GetAbsenceReasonActiveSuccess = "GET_ABSENCE_REASON_ACTIVE_SUCCESS";
export const GetAbsenceReasonActiveError = "GET_ABSENCE_REASON_ACTIVE_ERROR";
export const AddNewAbsenceReason = "ADD_NEW_ABSENCE_REASON";
export const AddNewAbsenceReasonSuccess = "ADD_NEW_ABSENCE_REASON_SUCCESS";
export const AddNewAbsenceReasonError = "ADD_NEW_ABSENCE_REASON_ERROR";
export const SetAbsenceReasonAssignments = "SET_ABSENCE_REASON_ASSIGNMENTS";
export const SetAbsenceReasonStatus = "SET_ABSENCE_REASON_STATUS";
export const GetAbsenceReason = "GET_ABSENCE_REASON";
export const GetAbsenceReasonSuccess = "GET_ABSENCE_REASON_SUCCESS";
export const GetAbsenceReasonError = "GET_ABSENCE_REASON_ERROR";
export const ShowAbsenceReasonEditModal = "SHOW_ABSENCE_REASON_EDIT_MODAL";
export const UpdateAbsenceReason = "UPDATE_ABSENCE_REASON";
export const UpdateAbsenceReasonSuccess = "UPDATE_ABSENCE_REASON_SUCCESS";
export const UpdateAbsenceReasonError = "UPDATE_ABSENCE_REASON_ERROR";
export const SetShowSubmitAbsenceReasonModal = "SET_SHOW_SUBMIT_ABSENCE_REASON_MODAL";
export const SetShowCancelAbsenceReasonModal = "SET_SHOW_CANCEL_ABSENCE_REASON_MODAL";
export const SubmitAbsenceReasonForReview = "SUBMIT_ABSENCE_REASON_FOR_REVIEW";
export const SubmitAbsenceReasonForReviewSuccess = "SUBMIT_DYNAMIC_FOR_REVIEW_SUCCESS";
export const SubmitAbsenceReasonForReviewError = "SUBMIT_DYNAMIC_FOR_REVIEW_ERROR";
export const CancelAbsenceReasonReview = "CANCEL_ABSENCE_REASON_REVIEW";
export const CancelAbsenceReasonReviewSuccess = "CANCEL_ABSENCE_REASON_REVIEW_SUCCESS";
export const CancelAbsenceReasonReviewError = "CANCEL_ABSENCE_REASON_REVIEW_ERROR";
export const StartAbsenceReasonDraft = "START_ABSENCE_REASON_DRAFT";
export const StartAbsenceReasonDraftSuccess = "START_ABSENCE_REASON_DRAFT_SUCCESS";
export const SetShowDiscardAbsenceReasonModal = "SET_SHOW_DISCARD_ABSENCE_REASON_MODAL";
export const DiscardAbsenceReasonDraft = "DISCARD_ABSENCE_REASON_DRAFT";
export const DiscardAbsenceReasonDraftSuccess = "DISCARD_ABSENCE_REASON_DRAFT_SUCCESS";
export const SetShowCancelDiscardAbsenceReasonModal =
  "SET_SHOW_CANCEL_DISCARD_ABSENCE_REASON_MODAL";
export const CancelAbsenceReasonReviewAndDiscard = "CANCEL_ABSENCE_REASON_REVIEW_AND_DISCARD";
export const DuplicateAbsenceReason = "DUPLICATE_ABSENCE_REASON";
export const DuplicateAbsenceReasonSuccess = "DUPLICATE_ABSENCE_REASON_SUCCESS";
export const SetShowDisableAbsenceReasonModal = "SET_SHOW_DISABLE_ABSENCE_REASON_MODAL";
export const DisableAbsenceReason = "DISBALE_ABSENCE_REASON";
export const DisableAbsenceReasonSuccess = "DISBALE_ABSENCE_REASON_SUCCESS";
export const StartAbsenceReasonDraftError = "START_ABSENCE_REASON_DRAFT_ERROR";
export const DiscardAbsenceReasonDraftError = "DISCARD_ABSENCE_REASON_DRAFT_ERROR";
export const DuplicateAbsenceReasonError = "DUPLICATE_ABSENCE_REASON_ERROR";
export const CancelAbsenceReasonReviewAndDiscardError =
  "CANCEL_ABSENCE_REASON_REVIEW_AND_DISCARD_ERROR";
export const DisableAbsenceReasonError = "DISABLE_ABSENCE_REASON_ERROR";
export const UpdateAbsenceReasonAssignments = "UPDATE_ABSENCE_REASON_ASSIGNMENTS";
export const UpdateAbsenceReasonAssignmentsError = "UPDATE_ABSENCE_REASON_ASSIGNMENTS_ERROR";
export const ShowEditAbsenceReasonAssignmentsModal = "SHOW_EDIT_ABSENCE_REASON_ASSIGNMENTS_MODAL";
export const SetAbsenceReasonsShowEditModal = "SET_ABSENCE_REASONS_SHOW_EDIT_MODAL";
export const ChangeAbsenceReasonsFilterState = "CHANGE_ABSENCE_REASONS_FILTER_STATE";
export const ChangeAbsenceReasonsFilterType = "CHANGE_ABSENCE_REASONS_FILTER_TYPE";
export const ExportLiveAbsenceReasons = "EXPORT_LIVE_ABSENCE_REASONS";
export const ExportLiveAbsenceReasonsSuccess = "EXPORT_LIVE_ABSENCE_REASONS_SUCCESS";
export const ExportLiveAbsenceReasonsError = "EXPORT_LIVE_ABSENCE_REASONS_ERROR";

// Alerts
export const GetAlertsList = "GET_ALERTS_LIST";
export const GetAlertsListSuccess = "GET_ALERT_LISTS_SUCCESS";
export const GetAlertsListError = "GET_ALERT_LISTS_ERROR";
export const GetAlert = "GET_ALERT";
export const GetAlertSuccess = "GET_ALERT_SUCCESS";
export const GetAlertError = "GET_ALERT_ERROR";
export const GetAlertSchema = "GET_ALERT_SCHEMA";
export const GetAlertSchemaSuccess = "GET_ALERT_SCHEMA_SUCCESS";
export const GetAlertSchemaError = "GET_ALERT_SCHEMA_ERROR";

export const NewAlert = "NEW_ALERT";
export const StartDraftAlert = "START_ALERT_DRAFT";
export const StartDraftAlertSuccess = "START_ALERT_DRAFT_SUCCESS";
export const StartDraftAlertError = "START_ALERT_DRAFT_ERROR";
export const DuplicateAlert = "DUPLICATE_ALERT";
export const DuplicateAlertSuccess = "DUPLICATE_ALERT_SUCCESS";
export const DuplicateAlertError = "DUPLICATE_ALERT_ERROR";
export const SetAlertDraft = "UPDATE_ALERT_DRAFT";
export const NewAlertAssignments = "NEW_ALERT_ASSIGNMENTS";
export const SetAlertAssignments = "SET_ALERT_ASSIGNMENTS";
export const SetAlertDraftAssignments = "SET_ALERT_DRAFT_ASSIGNMENTS";

export const AddAlert = "ADD_ALERT";
export const AddAlertSuccess = "ADD_ALERT_SUCCESS";
export const AddAlertError = "ADD_ALERT_ERROR";
export const UpdateAlert = "UPDATE_ALERT";
export const UpdateAlertSuccess = "UPDATE_ALERT_SUCCESS";
export const UpdateAlertError = "UPDATE_ALERT_ERROR";
export const DeleteBespokeRecipient = "DELETE_BESPOKE_RECIPIENT";
export const UpdateRecipientAssignments = "UPDATE_RECIPIENT_ASSIGNMENTS";
export const UpdateRecipientAssignmentsSuccess = "UPDATE_RECIPIENT_ASSIGNMENTS_SUCCESS";
export const UpdateRecipientAssignmentsError = "UPDATE_RECIPIENT_ASSIGNMENTS_ERROR";
export const UpdateAlertAssignments = "UPDATE_ALERT_ASSIGNMENTS";
export const UpdateAlertAssignmentsSuccess = "UPDATE_ALERT_ASSIGNMENTS_SUCCESS";
export const UpdateAlertAssignmentsError = "UPDATE_ALERT_ASSIGNMENTS_ERROR";
export const AddAlertAttachment = "ADD_ALERT_ATTACHMENT";
export const AddAlertAttachmentSuccess = "ADD_ALERT_ATTACHMENT_SUCCESS";
export const AddAlertAttachmentError = "ADD_ALERT_ATTACHMENT_ERROR";
export const DeleteAlertAttachment = "DELETE_ALERT_ATTACHMENT";
export const DeleteAlertAttachmentSuccess = "DELETE_ALERT_ATTACHMENT_SUCCESS";
export const DeleteAlertAttachmentError = "DELETE_ALERT_ATTACHMENT_ERROR";
export const DownloadAlertAttachment = "DOWNLOAD_ALERT_ATTACHMENT";
export const DownloadAlertAttachmentSuccess = "DOWNLOAD_ALERT_ATTACHMENT_SUCCESS";
export const DownloadAlertAttachmentError = "DOWNLOAD_ALERT_ATTACHMENT_ERROR";

export const DiscardAlertDraft = "DISCARD_ALERT_DRAFT";
export const DiscardAlertDraftSuccess = "DISCARD_ALERT_DRAFT_SUCCESS";
export const DiscardAlertDraftError = "DISCARD_ALERT_DRAFT_ERROR";
export const SubmitAlertForReview = "SUBMIT_ALERT_FOR_REVIEW";
export const SubmitAlertForReviewSuccess = "SUBMIT_ALERT_FOR_REVIEW_SUCCESS";
export const SubmitAlertForReviewError = "SUBMIT_ALERT_FOR_REVIEW_ERROR";
export const CancelAlertReview = "CANCEL_ALERT_REVIEW";
export const CancelAlertReviewSuccess = "CANCEL_ALERT_REVIEW_SUCCESS";
export const CancelAlertReviewError = "CANCEL_ALERT_REVIEW_ERROR";
export const CancelAlertReviewAndDiscard = "CANCEL_ALERT_REVIEW_AND_DISCARD_REVIEW";
export const CancelAlertReviewAndDiscardSuccess = "CANCEL_ALERT_REVIEW_AND_DISCARD_SUCCESS";
export const CancelAlertReviewAndDiscardError = "CANCEL_ALERT_REVIEW_AND_DISCARD_ERROR";
export const DisableAlert = "DISABLE_ALERT";
export const DisableAlertSuccess = "DISABLE_ALERT_SUCCESS";
export const DisableAlertError = "DISABLE_ALERT_ERROR";

export const SetAlertsEnabled = "SET_ALERTS_ENABLED";
export const SetAlertsStatus = "SET_ALERTS_STATUS";
export const SetAlertModalStep = "SET_ALERT_MODAL_STEP";
export const SetShowAddAlertModal = "SET_SHOW_ADD_ALERT_MODAL";
export const SetShowEditAlertModal = "SET_SHOW_EDIT_ALERT_MODAL";
export const SetShowEditAlertAssignmentsModal = "SET_SHOW_EDIT_ALERT_ASSIGNMENTS_MODAL";
export const SetShowAddAlertRecipientModal = "SET_SHOW_ADD_ALERT_RECIPIENT_MODAL";
export const SetShowDeleteAlertRecipientModal = "SET_SHOW_DELETE_ALERT_RECIPIENT_MODAL";
export const SetShowDiscardAlertModal = "SET_SHOW_DISCARD_ALERT_MODAL";
export const SetShowSubmitAlertModal = "SET_SHOW_SUBMIT_ALERT_MODAL";
export const SetShowCancelAlertModal = "SET_SHOW_CANCEL_ALERT_MODAL";
export const SetShowCancelDiscardAlertModal = "SET_SHOW_CANCEL_DISCARD_ALERT_MODAL";
export const SetShowDisableAlertModal = "SET_SHOW_DISABLE_ALERT_MODAL";
export const SetShowAddAlertAttachmentModal = "SET_SHOW_ADD_ALERT_ATTACHMENT_MODAL";
export const SetShowDeleteAlertAttachmentModal = "SET_SHOW_DELETE_ALERT_ATTACHMENT_MODAL";

// Referrals
export const GetReferralList = "GET_REFERRAL_LIST";
export const GetReferralListSuccess = "GET_REFERRAL_LISTS_SUCCESS";
export const GetReferralListError = "GET_REFERRAL_LISTS_ERROR";
export const GetReferral = "GET_REFERRAL";
export const GetReferralSuccess = "GET_REFERRAL_SUCCESS";
export const GetReferralError = "GET_REFERRAL_ERROR";
export const GetReferralSchema = "GET_REFERRAL_SCHEMA";
export const GetReferralSchemaSuccess = "GET_REFERRAL_SCHEMA_SUCCESS";
export const GetReferralSchemaError = "GET_REFERRAL_SCHEMA_ERROR";

export const NewReferral = "NEW_REFERRAL";
export const StartDraftReferral = "START_REFERRAL_DRAFT";
export const StartDraftReferralSuccess = "START_REFERRAL_DRAFT_SUCCESS";
export const StartDraftReferralError = "START_REFERRAL_DRAFT_ERROR";
export const DuplicateReferral = "DUPLICATE_REFERRAL";
export const DuplicateReferralSuccess = "DUPLICATE_REFERRAL_SUCCESS";
export const DuplicateReferralError = "DUPLICATE_REFERRAL_ERROR";
export const SetReferralDraft = "UPDATE_REFERRAL_DRAFT";
export const NewReferralAssignments = "NEW_REFERRAL_ASSIGNMENTS";
export const SetReferralAssignments = "SET_REFERRAL_ASSIGNMENTS";

export const AddReferral = "ADD_REFERRAL";
export const AddReferralSuccess = "ADD_REFERRAL_SUCCESS";
export const AddReferralError = "ADD_REFERRAL_ERROR";
export const UpdateReferral = "UPDATE_REFERRAL";
export const UpdateReferralSuccess = "UPDATE_REFERRAL_SUCCESS";
export const UpdateReferralError = "UPDATE_REFERRAL_ERROR";
export const UpdateReferralAssignments = "UPDATE_REFERRAL_ASSIGNMENTS";
export const UpdateReferralAssignmentsSuccess = "UPDATE_REFERRAL_ASSIGNMENTS_SUCCESS";
export const UpdateReferralAssignmentsError = "UPDATE_REFERRAL_ASSIGNMENTS_ERROR";
export const AddReferralAttachment = "ADD_REFERRAL_ATTACHMENT";
export const AddReferralAttachmentSuccess = "ADD_REFERRAL_ATTACHMENT_SUCCESS";
export const AddReferralAttachmentError = "ADD_REFERRAL_ATTACHMENT_ERROR";
export const DeleteReferralAttachment = "DELETE_REFERRAL_ATTACHMENT";
export const DeleteReferralAttachmentSuccess = "DELETE_REFERRAL_ATTACHMENT_SUCCESS";
export const DeleteReferralAttachmentError = "DELETE_REFERRAL_ATTACHMENT_ERROR";

export const DiscardReferralDraft = "DISCARD_REFERRAL_DRAFT";
export const DiscardReferralDraftSuccess = "DISCARD_REFERRAL_DRAFT_SUCCESS";
export const DiscardReferralDraftError = "DISCARD_REFERRAL_DRAFT_ERROR";
export const SubmitReferralForReview = "SUBMIT_REFERRAL_FOR_REVIEW";
export const SubmitReferralForReviewSuccess = "SUBMIT_REFERRAL_FOR_REVIEW_SUCCESS";
export const SubmitReferralForReviewError = "SUBMIT_REFERRAL_FOR_REVIEW_ERROR";
export const CancelReferralReview = "CANCEL_REFERRAL_REVIEW";
export const CancelReferralReviewSuccess = "CANCEL_REFERRAL_REVIEW_SUCCESS";
export const CancelReferralReviewError = "CANCEL_REFERRAL_REVIEW_ERROR";
export const CancelReferralReviewAndDiscard = "CANCEL_REFERRAL_REVIEW_AND_DISCARD_REVIEW";
export const CancelReferralReviewAndDiscardSuccess = "CANCEL_REFERRAL_REVIEW_AND_DISCARD_SUCCESS";
export const CancelReferralReviewAndDiscardError = "CANCEL_REFERRAL_REVIEW_AND_DISCARD_ERROR";
export const DisableReferral = "DISABLE_REFERRAL";
export const DisableReferralSuccess = "DISABLE_REFERRAL_SUCCESS";
export const DisableReferralError = "DISABLE_REFERRAL_ERROR";

export const SetReferralEnabled = "SET_REFERRAL_ENABLED";
export const SetReferralStatus = "SET_REFERRAL_STATUS";
export const SetReferralModalStep = "SET_REFERRAL_MODAL_STEP";
export const SetShowAddReferralModal = "SET_SHOW_ADD_REFERRAL_MODAL";
export const SetShowEditReferralModal = "SET_SHOW_EDIT_REFERRAL_MODAL";
export const SetShowEditReferralAssignmentsModal = "SET_SHOW_EDIT_REFERRAL_ASSIGNMENTS_MODAL";
export const SetShowDiscardReferralModal = "SET_SHOW_DISCARD_REFERRAL_MODAL";
export const SetShowSubmitReferralModal = "SET_SHOW_SUBMIT_REFERRAL_MODAL";
export const SetShowCancelReferralModal = "SET_SHOW_CANCEL_REFERRAL_MODAL";
export const SetShowCancelDiscardReferralModal = "SET_SHOW_CANCEL_DISCARD_REFERRAL_MODAL";
export const SetShowDisableReferralModal = "SET_SHOW_DISABLE_REFERRAL_MODAL";
export const SetShowAddReferralAttachmentModal = "SET_SHOW_ADD_REFERRAL_ATTACHMENT_MODAL";

// Return to Work (RTW)
export const GetRTWLiveProcesses = "GET_RTW_LIVE_PROCESSES";
export const GetRTWLiveProcessesSuccess = "GET_RTW_LIVE_PROCESSES_SUCCESS";
export const GetRTWLiveProcessesError = "GET_RTW_LIVE_PROCESSES_ERROR";

export const GetRTWPendingProcesses = "GET_RTW_PENDING_PROCESSES";
export const GetRTWPendingProcessesSuccess = "GET_RTW_PENDING_PROCESSES_SUCCESS";
export const GetRTWPendingProcessesError = "GET_RTW_PENDING_PROCESSES_ERROR";

export const GetRTWDraftProcesses = "GET_RTW_DRAFT_PROCESSES";
export const GetRTWDraftProcessesSuccess = "GET_RTW_DRAFT_PROCESSES_SUCCESS";
export const GetRTWDraftProcessesError = "GET_RTW_DRAFT_PROCESSES_ERROR";

export const SetRTWLiveProcessesFilter = "SET_RTWLIVE_PROCESSES_FILTER";

export const GetRtw = "GET_RTW";
export const GetRtwSuccess = "GET_RTW_SUCCESS";
export const GetRtwError = "GET_RTW_ERROR";
export const GetRtwSchema = "GET_RTW_SCHEMA";
export const GetRtwSchemaSuccess = "GET_RTW_SCHEMA_SUCCESS";
export const GetRtwSchemaError = "GET_RTW_SCHEMA_ERROR";

export const NewRtw = "NEW_RTW";
export const StartDraftRtw = "START_RTW_DRAFT";
export const StartDraftRtwSuccess = "START_RTW_DRAFT_SUCCESS";
export const StartDraftRtwError = "START_RTW_DRAFT_ERROR";
export const DuplicateRtw = "DUPLICATE_RTW";
export const DuplicateRtwSuccess = "DUPLICATE_RTW_SUCCESS";
export const DuplicateRtwError = "DUPLICATE_RTW_ERROR";
export const SetRtwDraft = "UPDATE_RTW_DRAFT";
export const NewRtwAssignments = "NEW_RTW_ASSIGNMENTS";
export const SetRtwAssignments = "SET_RTW_ASSIGNMENTS";
export const SetRtwDraftAssignments = "SET_RTW_DRAFT_ASSIGNMENTS";

export const AddRtw = "ADD_RTW";
export const AddRtwSuccess = "ADD_RTW_SUCCESS";
export const AddRtwError = "ADD_RTW_ERROR";
export const UpdateRtw = "UPDATE_RTW";
export const UpdateRtwSuccess = "UPDATE_RTW_SUCCESS";
export const UpdateRtwError = "UPDATE_RTW_ERROR";
export const UpdateRtwAssignments = "UPDATE_RTW_ASSIGNMENTS";
export const UpdateRtwAssignmentsSuccess = "UPDATE_RTW_ASSIGNMENTS_SUCCESS";
export const UpdateRtwAssignmentsError = "UPDATE_RTW_ASSIGNMENTS_ERROR";
export const AddRtwAttachment = "ADD_RTW_ATTACHMENT";
export const AddRtwAttachmentSuccess = "ADD_RTW_ATTACHMENT_SUCCESS";
export const AddRtwAttachmentError = "ADD_RTW_ATTACHMENT_ERROR";
export const DeleteRtwAttachment = "DELETE_RTW_ATTACHMENT";
export const DeleteRtwAttachmentSuccess = "DELETE_RTW_ATTACHMENT_SUCCESS";
export const DeleteRtwAttachmentError = "DELETE_RTW_ATTACHMENT_ERROR";

export const DiscardRtwDraft = "DISCARD_RTW_DRAFT";
export const DiscardRtwDraftSuccess = "DISCARD_RTW_DRAFT_SUCCESS";
export const DiscardRtwDraftError = "DISCARD_RTW_DRAFT_ERROR";
export const SubmitRtwForReview = "SUBMIT_RTW_FOR_REVIEW";
export const SubmitRtwForReviewSuccess = "SUBMIT_RTW_FOR_REVIEW_SUCCESS";
export const SubmitRtwForReviewError = "SUBMIT_RTW_FOR_REVIEW_ERROR";
export const CancelRtwReview = "CANCEL_RTW_REVIEW";
export const CancelRtwReviewSuccess = "CANCEL_RTW_REVIEW_SUCCESS";
export const CancelRtwReviewError = "CANCEL_RTW_REVIEW_ERROR";
export const CancelRtwReviewAndDiscard = "CANCEL_RTW_REVIEW_AND_DISCARD_REVIEW";
export const CancelRtwReviewAndDiscardSuccess = "CANCEL_RTW_REVIEW_AND_DISCARD_SUCCESS";
export const CancelRtwReviewAndDiscardError = "CANCEL_RTW_REVIEW_AND_DISCARD_ERROR";
export const DisableRtw = "DISABLE_RTW";
export const DisableRtwSuccess = "DISABLE_RTW_SUCCESS";
export const DisableRtwError = "DISABLE_RTW_ERROR";

export const SetRtwEnabled = "SET_RTW_ENABLED";
export const SetRtwStatus = "SET_RTW_STATUS";
export const SetRtwModalStep = "SET_RTW_MODAL_STEP";
export const SetShowAddRtwModal = "SET_SHOW_ADD_RTW_MODAL";
export const SetShowEditRtwModal = "SET_SHOW_EDIT_RTW_MODAL";
export const SetShowEditRtwAssignmentsModal = "SET_SHOW_EDIT_RTW_ASSIGNMENTS_MODAL";
export const SetShowDiscardRtwModal = "SET_SHOW_DISCARD_RTW_MODAL";
export const SetShowSubmitRtwModal = "SET_SHOW_SUBMIT_RTW_MODAL";
export const SetShowCancelRtwModal = "SET_SHOW_CANCEL_RTW_MODAL";
export const SetShowCancelDiscardRtwModal = "SET_SHOW_CANCEL_DISCARD_RTW_MODAL";
export const SetShowDisableRtwModal = "SET_SHOW_DISABLE_RTW_MODAL";
export const SetShowAddRtwAttachmentModal = "SET_SHOW_ADD_RTW_ATTACHMENT_MODAL";
export const ChangeAddFileInProgress = "CHANGE_ADD_FILE_IN_PROGRESS";

// Absence Monitoring
export const GetAbsenceMonitoringList = "GET_ABSENCE_MONITORING_LIST";
export const GetAbsenceMonitoringListSuccess = "GET_ABSENCE_MONITORING_LISTS_SUCCESS";
export const GetAbsenceMonitoringListError = "GET_ABSENCE_MONITORING_LISTS_ERROR";
export const GetAbsenceMonitoring = "GET_ABSENCE_MONITORING";
export const GetAbsenceMonitoringSuccess = "GET_ABSENCE_MONITORING_SUCCESS";
export const GetAbsenceMonitoringError = "GET_ABSENCE_MONITORING_ERROR";
export const GetAbsenceMonitoringSchema = "GET_ABSENCE_MONITORING_SCHEMA";
export const GetAbsenceMonitoringSchemaSuccess = "GET_ABSENCE_MONITORING_SCHEMA_SUCCESS";
export const GetAbsenceMonitoringSchemaError = "GET_ABSENCE_MONITORING_SCHEMA_ERROR";

export const NewAbsenceMonitoring = "NEW_ABSENCE_MONITORING";
export const StartDraftAbsenceMonitoring = "START_ABSENCE_MONITORING_DRAFT";
export const StartDraftAbsenceMonitoringSuccess = "START_ABSENCE_MONITORING_DRAFT_SUCCESS";
export const StartDraftAbsenceMonitoringError = "START_ABSENCE_MONITORING_DRAFT_ERROR";
export const DuplicateAbsenceMonitoring = "DUPLICATE_ABSENCE_MONITORING";
export const DuplicateAbsenceMonitoringSuccess = "DUPLICATE_ABSENCE_MONITORING_SUCCESS";
export const DuplicateAbsenceMonitoringError = "DUPLICATE_ABSENCE_MONITORING_ERROR";
export const SetAbsenceMonitoringDraft = "UPDATE_ABSENCE_MONITORING_DRAFT";
export const NewAbsenceMonitoringAssignments = "NEW_ABSENCE_MONITORING_ASSIGNMENTS";
export const SetAbsenceMonitoringAssignments = "SET_ABSENCE_MONITORING_ASSIGNMENTS";

export const AddAbsenceMonitoring = "ADD_ABSENCE_MONITORING";
export const AddAbsenceMonitoringSuccess = "ADD_ABSENCE_MONITORING_SUCCESS";
export const AddAbsenceMonitoringError = "ADD_ABSENCE_MONITORING_ERROR";
export const UpdateAbsenceMonitoring = "UPDATE_ABSENCE_MONITORING";
export const UpdateAbsenceMonitoringSuccess = "UPDATE_ABSENCE_MONITORING_SUCCESS";
export const UpdateAbsenceMonitoringError = "UPDATE_ABSENCE_MONITORING_ERROR";
export const UpdateAbsenceMonitoringAssignments = "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS";
export const SetAbsenceMonitoringDraftAssignments = "SET_ABSENCE_MONITORING_DRAFT_ASSIGNMENTS";

export const UpdateAbsenceMonitoringAssignmentsSuccess =
  "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS_SUCCESS";
export const UpdateAbsenceMonitoringAssignmentsError =
  "UPDATE_ABSENCE_MONITORING_ASSIGNMENTS_ERROR";
export const AddAbsenceMonitoringAttachment = "ADD_ABSENCE_MONITORING_ATTACHMENT";
export const AddAbsenceMonitoringAttachmentSuccess = "ADD_ABSENCE_MONITORING_ATTACHMENT_SUCCESS";
export const AddAbsenceMonitoringAttachmentError = "ADD_ABSENCE_MONITORING_ATTACHMENT_ERROR";
export const DeleteAbsenceMonitoringAttachment = "DELETE_ABSENCE_MONITORING_ATTACHMENT";
export const DeleteAbsenceMonitoringAttachmentSuccess =
  "DELETE_ABSENCE_MONITORING_ATTACHMENT_SUCCESS";
export const DeleteAbsenceMonitoringAttachmentError = "DELETE_ABSENCE_MONITORING_ATTACHMENT_ERROR";

export const DiscardAbsenceMonitoringDraft = "DISCARD_ABSENCE_MONITORING_DRAFT";
export const DiscardAbsenceMonitoringDraftSuccess = "DISCARD_ABSENCE_MONITORING_DRAFT_SUCCESS";
export const DiscardAbsenceMonitoringDraftError = "DISCARD_ABSENCE_MONITORING_DRAFT_ERROR";
export const SubmitAbsenceMonitoringForReview = "SUBMIT_ABSENCE_MONITORING_FOR_REVIEW";
export const SubmitAbsenceMonitoringForReviewSuccess =
  "SUBMIT_ABSENCE_MONITORING_FOR_REVIEW_SUCCESS";
export const SubmitAbsenceMonitoringForReviewError = "SUBMIT_ABSENCE_MONITORING_FOR_REVIEW_ERROR";
export const CancelAbsenceMonitoringReview = "CANCEL_ABSENCE_MONITORING_REVIEW";
export const CancelAbsenceMonitoringReviewSuccess = "CANCEL_ABSENCE_MONITORING_REVIEW_SUCCESS";
export const CancelAbsenceMonitoringReviewError = "CANCEL_ABSENCE_MONITORING_REVIEW_ERROR";
export const CancelAbsenceMonitoringReviewAndDiscard =
  "CANCEL_ABSENCE_MONITORING_REVIEW_AND_DISCARD_REVIEW";
export const CancelAbsenceMonitoringReviewAndDiscardSuccess =
  "CANCEL_ABSENCE_MONITORING_REVIEW_AND_DISCARD_SUCCESS";
export const CancelAbsenceMonitoringReviewAndDiscardError =
  "CANCEL_ABSENCE_MONITORING_REVIEW_AND_DISCARD_ERROR";
export const DisableAbsenceMonitoring = "DISABLE_ABSENCE_MONITORING";
export const DisableAbsenceMonitoringSuccess = "DISABLE_ABSENCE_MONITORING_SUCCESS";
export const DisableAbsenceMonitoringError = "DISABLE_ABSENCE_MONITORING_ERROR";

export const SetAbsenceMonitoringEnabled = "SET_ABSENCE_MONITORING_ENABLED";
export const SetAbsenceMonitoringStatus = "SET_ABSENCE_MONITORING_STATUS";
export const SetAbsenceMonitoringModalStep = "SET_ABSENCE_MONITORING_MODAL_STEP";
export const SetShowAddAbsenceMonitoringModal = "SET_SHOW_ADD_ABSENCE_MONITORING_MODAL";
export const SetShowEditAbsenceMonitoringModal = "SET_SHOW_EDIT_ABSENCE_MONITORING_MODAL";
export const SetShowEditAbsenceMonitoringAssignmentsModal =
  "SET_SHOW_EDIT_ABSENCE_MONITORING_ASSIGNMENTS_MODAL";
export const SetShowDiscardAbsenceMonitoringModal = "SET_SHOW_DISCARD_ABSENCE_MONITORING_MODAL";
export const SetShowSubmitAbsenceMonitoringModal = "SET_SHOW_SUBMIT_ABSENCE_MONITORING_MODAL";
export const SetShowCancelAbsenceMonitoringModal = "SET_SHOW_CANCEL_ABSENCE_MONITORING_MODAL";
export const SetShowCancelDiscardAbsenceMonitoringModal =
  "SET_SHOW_CANCEL_DISCARD_ABSENCE_MONITORING_MODAL";
export const SetShowDisableAbsenceMonitoringModal = "SET_SHOW_DISABLE_ABSENCE_MONITORING_MODAL";

// Special Contacts
export const GetSpecialContacts = "GET_SPECIAL_CONTACTS";
export const GetSpecialContactsSuccess = "GET_SPECIAL_CONTACTS_SUCCESS";
export const GetSpecialContactsError = "GET_SPECIAL_CONTACTS_ERROR";
export const GetSpecialContactsEmployees = "GET_SPECIAL_CONTACTS_EMPLOYEES";
export const GetSpecialContactsEmployeesSuccess = "GET_SPECIAL_CONTACTS_EMPLOYEES_SUCCESS";
export const GetSpecialContactsEmployeesError = "GET_SPECIAL_CONTACTS_EMPLOYEES_ERROR";
export const ClearSpecialContactsEmployees = "CLEAR_SPECIAL_CONTACTS_EMPLOYEES";
export const AddSpecialContact = "ADD_SPECIAL_CONTACT";
export const AddSpecialContactSuccess = "ADD_SPECIAL_CONTACT_SUCCESS";
export const AddSpecialContactError = "ADD_SPECIAL_CONTACT_ERROR";
export const UpdateSpecialContact = "UPDATE_SPECIAL_CONTACT";
export const UpdateSpecialContactSuccess = "UPDATE_SPECIAL_CONTACT_SUCCESS";
export const UpdateSpecialContactError = "UPDATE_SPECIAL_CONTACT_ERROR";
export const RemoveSpecialContact = "REMOVE_SPECIAL_CONTACT";
export const RemoveSpecialContactSuccess = "REMOVE_SPECIAL_CONTACT_SUCCESS";
export const RemoveSpecialContactError = "REMOVE_SPECIAL_CONTACT_ERROR";
export const SetSpecialContactsListOptions = "SET_SPECIAL_CONTACTS_LIST_OPTIONS";
export const SetCurrentSpecialContact = "SET_SHOW_CURRENT_SPECIAL_CONTACT";
export const SetShowAddSpecialContactModal = "SHOW_ADD_SPECIAL_CONTACT_MODAL";
export const SetShowEditSpecialContactModal = "SHOW_EDIT_SPECIAL_CONTACT_MODAL";
export const SetShowDeleteSpecialContactModal = "SHOW_DELETE_SPECIAL_CONTACT_MODAL";

// Special Contact Types
export const GetSpecialContactTypes = "GET_SPECIAL_CONTACT_TYPES";
export const GetSpecialContactTypesSuccess = "GET_SPECIAL_CONTACT_TYPES_SUCCESS";
export const GetSpecialContactTypesError = "GET_SPECIAL_CONTACT_TYPES_ERROR";
export const AddSpecialContactType = "ADD_SPECIAL_CONTACT_TYPE";
export const AddSpecialContactTypeSuccess = "ADD_SPECIAL_CONTACT_TYPE_SUCCESS";
export const AddSpecialContactTypeError = "ADD_SPECIAL_CONTACT_TYPE_ERROR";
export const UpdateSpecialContactType = "UPDATE_SPECIAL_CONTACT_TYPE";
export const UpdateSpecialContactTypeSuccess = "UPDATE_SPECIAL_CONTACT_TYPE_SUCCESS";
export const UpdateSpecialContactTypeError = "UPDATE_SPECIAL_CONTACT_TYPE_ERROR";
export const RemoveSpecialContactType = "REMOVE_SPECIAL_CONTACT_TYPE";
export const RemoveSpecialContactTypeSuccess = "REMOVE_SPECIAL_CONTACT_TYPE_SUCCESS";
export const RemoveSpecialContactTypeError = "REMOVE_SPECIAL_CONTACT_TYPE_ERROR";
export const SetCurrentSpecialContactType = "SET_SHOW_CURRENT_SPECIAL_CONTACT_TYPE";
export const SetShowSpecialContactTypeModal = "SHOW_SPECIAL_CONTACT_TYPE_MODAL";
export const SetShowDeleteSpecialContactTypeModal = "SHOW_DELETE_SPECIAL_CONTACT_TYPE_MODAL";

// User Permissions
export const GetEffectiveUserPermissions = "GET_EFFECTIVE_USER_PERMISSIONS";
export const GetEffectiveUserPermissionsSuccess = "GET_EFFECTIVE_USER_PERMISSIONS_SUCCESS";
export const GetEffectiveUserPermissionsError = "GET_EFFECTIVE_USER_PERMISSIONS_ERROR";
export const UpdateEffectiveUserPermissions = "UPDATE_EFFECTIVE_USER_PERMISSIONS";
export const UpdateEffectiveUserPermissionsSuccess = "UPDATE_EFFECTIVE_USER_PERMISSIONS_SUCCESS";
export const UpdateEffectiveUserPermissionsError = "UPDATE_EFFECTIVE_USER_PERMISSIONS_ERROR";
export const GetEffectiveUserPermissionsSchema = "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA";
export const GetEffectiveUserPermissionsSchemaSuccess =
  "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA_SUCCESS";
export const GetEffectiveUserPermissionsSchemaError = "GET_EFFECTIVE_USER_PERMISSIONS_SCHEMA_ERROR";

// User Accounts
export const GetUserAccounts = "GET_USER_ACCOUNTS";
export const GetUserAccountsSuccess = "GET_USER_ACCOUNTS_SUCCESS";
export const GetUserAccountsError = "GET_USER_ACCOUNTS_ERROR";
export const ExportUserAccounts = "EXPORT_USER_ACCOUNTS";
export const ExportUserAccountsSuccess = "EXPORT_USER_ACCOUNTS_SUCCESS";
export const ExportUserAccountsError = "EXPORT_USER_ACCOUNTS_ERROR";

// Reporting Parameters
export const GetReportingParameters = "GET_REPORTING_PARAMETERS";
export const GetReportingParametersSuccess = "GET_REPORTING_PARAMETERS_SUCCESS";
export const GetReportingParametersError = "GET_REPORTING_PARAMETERS_ERROR";
export const UpdateReportingParameters = "UPDATE_REPORTING_PARAMETERS";
export const UpdateReportingParametersSuccess = "UPDATE_REPORTING_PARAMETERS_SUCCESS";
export const UpdateReportingParametersError = "UPDATE_REPORTING_PARAMETERS_ERROR";
export const GetReportingParametersSchema = "GET_REPORTING_PARAMETERS_SCHEMA";
export const GetReportingParametersSchemaSuccess = "GET_REPORTING_PARAMETERS_SCHEMA_SUCCESS";
export const GetReportingParametersSchemaError = "GET_REPORTING_PARAMETERS_SCHEMA_ERROR";
export const GetReasonsToBeExcluded = "GET_REASONS_TO_BE_EXCLUDED";
export const GetReasonsToBeExcludedSuccess = "GET_REASONS_TO_BE_EXCLUDED_SUCCESS";
export const GetReasonsToBeExcludedError = "GET_REASONS_TO_BE_EXCLUDED_ERROR";
export const CreateReasonToBeExcluded = "CREATE_REASON_TO_BE_EXCLUDED";
export const CreateReasonToBeExcludedSuccess = "CREATE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const CreateReasonToBeExcludedError = "CREATE_REASON_TO_BE_EXCLUDED_ERROR";
export const UpdateReasonToBeExcluded = "UPDATE_REASON_TO_BE_EXCLUDED";
export const UpdateReasonToBeExcludedSuccess = "UPDATE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const UpdateReasonToBeExcludedError = "UPDATE_REASON_TO_BE_EXCLUDED_ERROR";
export const DeleteReasonToBeExcluded = "DELETE_REASON_TO_BE_EXCLUDED";
export const DeleteReasonToBeExcludedSuccess = "DELETE_REASON_TO_BE_EXCLUDED_SUCCESS";
export const DeleteReasonToBeExcludedError = "DELETE_REASON_TO_BE_EXCLUDED_ERROR";
export const GetReasonsToBeExcludedSchema = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA";
export const GetReasonsToBeExcludedSchemaSuccess = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA_SUCCESS";
export const GetReasonsToBeExcludedSchemaError = "GET_REASONS_TO_BE_EXCLUDED_SCHEMA_ERROR";
export const ToggleReasonsToBeExcludedModal = "TOGGLE_REASONS_TO_BE_EXCLUDED_MODAL";
export const ToggleReportingParametersModal = "TOGGLE_REPORTING_PARAMETERS_MODAL";
export const SetEditReasonToBeExcluded = "SET_EDIT_REASON_TO_BE_EXCLUDED";
export const ToggleDeleteReasonToBeExcludedConfirmModal =
  "TOGGLE_DELETE_REASON_TO_BE_EXCLUDED_CONFIRM_MODAL";
export const ToggleScheduledReportsModal = "TOGGLE_SCHEDULED_REPORTS_MODAL";
export const ToggleScheduledReportsWarningModal = "TOGGLE_SCHEDULED_REPORTS_WARNING_MODAL";

// Service Summary
export const GetServiceSummary = "GET_SERVICE_SUMMARY";
export const GetServiceSummarySuccess = "GET_SERVICE_SUMMARY_SUCCESS";
export const GetServiceSummaryError = "GET_SERVICE_SUMMARY_ERROR";
export const GetServiceSummaryPendingChanges = "GET_SERVICE_SUMMARY_PENDING_CHANGES";
export const GetServiceSummaryPendingChangesSuccess = "GET_SERVICE_SUMMARY_PENDING_CHANGES_SUCCESS";
export const GetServiceSummaryPendingChangesError = "GET_SERVICE_SUMMARY_PENDING_CHANGES_ERROR";
export const GetServiceSummaryCompletedChanges = "GET_SERVICE_SUMMARY_COMPLETED_CHANGES";
export const GetServiceSummaryCompletedChangesSuccess = "GET_SERVICE_SUMMARY_COMPLETED_SUCCESS";
export const GetServiceSummaryCompletedChangesError = "GET_SERVICE_SUMMARY_COMPLETED_ERROR";
export const GetServiceSummaryDraftChanges = "GET_SERVICE_SUMMARY_DRAFT_CHANGES";
export const GetServiceSummaryDraftChangesSuccess = "GET_SERVICE_SUMMARY_DRAFT_CHANGES_SUCCESS";
export const GetServiceSummaryDraftChangesError = "GET_SERVICE_SUMMARY_DRAFT_CHANGES_ERROR";
export const SetChangeSetDetails = "SET_CHANGE_SET_DETAILS";
export const SetPendingChangesSort = "SET_PENDING_CHANGES_SORT";
export const SetCompletedChangesSort = "SET_COMPLETED_CHANGES_SORT";
export const SetDraftChangesSort = "SET_DRAFT_CHANGES_SORT";
export const ToggleDeleteChangeSetConfirmModal = "TOGGLE_DELETE_CHANGE_SET_CONFIRM_MODAL";
export const DeleteChangeSet = "DELETE_CHANGE_SET";
export const DeleteChangeSetSuccess = "DELETE_CHANGE_SET_SUCCESS";
export const DeleteChangeSetError = "DELETE_CHANGE_SET_ERROR";

// Employee Identify
export const GetEmployeeIdentityData = "GET_EMPLOYEE_IDENTITY_DATA";
export const GetEmployeeIdentityDataSuccess = "GET_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const GetEmployeeIdentityDataError = "GET_EMPLOYEE_IDENTITY_DATA_ERROR";
export const DiscardPlatformDataSecurityEmployeeIdentity = "DISCARD_EMPLOYEE_IDENTITY_DATA";
export const DiscardPlatformDataSecurityEmployeeIdentitySuccess =
  "DISCARD_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const DiscardPlatformDataSecurityEmployeeIdentityError =
  "DISCARD_EMPLOYEE_IDENTITY_DATA_ERROR";
export const SubmitPlatformDataSecurityEmployeeIdentity = "SUBMIT_EMPLOYEE_IDENTITY_DATA";
export const SubmitPlatformDataSecurityEmployeeIdentitySuccess =
  "SUBMIT_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const SubmitPlatformDataSecurityEmployeeIdentityError =
  "SUBMIT_EMPLOYEE_IDENTITY_DATA_ERROR";
export const UpdatePlatformDataSecurityEmployeeIdentity = "UPDATE_EMPLOYEE_IDENTITY_DATA";
export const UpdatePlatformDataSecurityEmployeeIdentitySuccess =
  "UPDATE_EMPLOYEE_IDENTITY_DATA_SUCCESS";
export const UpdatePlatformDataSecurityEmployeeIdentityError =
  "UPDATE_EMPLOYEE_IDENTITY_DATA_ERROR";
export const GetEmployeeIdentityDataEffective = "GET_EMPLOYEE_IDENTITY_DATA_EFFECTIVE";
export const GetEmployeeIdentityDataEffectiveSuccess =
  "GET_EMPLOYEE_IDENTITY_DATA_EFFECTIVE_SUCCESS";
export const GetEmployeeIdentityDataEffectiveError = "GET_EMPLOYEE_IDENTITY_DATA_EFFECTIVE_ERROR";
export const GetEmployeeIdentityChangeSet = "GET_EMPLOYEE_IDENTITY_CHANGESET";
export const GetEmployeeIdentityChangeSetSuccess = "GET_EMPLOYEE_IDENTITY_CHANGESET_SUCCESS";
export const GetEmployeeIdentityChangeSetError = "GET_EMPLOYEE_IDENTITY_CHANGESET_ERROR";
export const GetPlatformDataSecurityEmployeeIdentitySchema = "GET_EMPLOYEE_IDENTITY_SCHEMA";
export const GetPlatformDataSecurityEmployeeIdentitySchemaSuccess =
  "GET_EMPLOYEE_IDENTITY_SCHEMA_SUCCESS";
export const GetPlatformDataSecurityEmployeeIdentitySchemaError =
  "GET_EMPLOYEE_IDENTITY_SCHEMA_ERROR";
export const SetEmployeeIdentityMainOptionsModalVisibility =
  "SET_EMPLOYEE_IDENTITY_MAIN_OPTIONS_MODAL_VISIBILITY";
export const SetEmployeeIdentitySecurityQuestionsModalVisibility =
  "SET_EMPLOYEE_IDENTITY_SECURITY_QUESTIONS_MODAL_VISIBILITY";
export const SetEmployeeIdentityAccessAuditModalVisibility =
  "SET_EMPLOYEE_IDENTITY_ACCESS_AUDIT_MODAL_VISIBILITY";

// Dynamic Questions
export const GetDynamicQuestions = "GET_DYNAMIC_QUESTIONS";
export const GetDynamicQuestionsSuccess = "GET_DYNAMIC_QUESTIONS_SUCCESS";
export const GetDynamicQuestionsError = "GET_DYNAMIC_QUESTIONS_ERROR";
export const ShowAddDynamicQuestionModal = "SHOW_ADD_DYNAMIC_QUESTION_MODAL";
export const NewDynamicQuestion = "NEW_DYNAMIC_QUESTION";
export const UpdateDynamicQuestionDraft = "UPDATE_DYNAMIC_QUESTION_DRAFT";
export const SetDynamicQuestionRevisionSchema = "SET_DYNAMIC_QUESTION_REVISION_SCHEMA";
export const GetDynamicQuestionActive = "GET_DYNAMIC_QUESTION_ACTIVE";
export const GetDynamicQuestionActiveSuccess = "GET_DYNAMIC_QUESTION_ACTIVE_SUCCESS";
export const GetDynamicQuestionActiveError = "GET_DYNAMIC_QUESTION_ACTIVE_ERROR";
export const AddNewDynamicQuestion = "ADD_NEW_DYNAMIC_QUESTION";
export const AddNewDynamicQuestionSuccess = "ADD_NEW_DYNAMIC_QUESTION_SUCCESS";
export const AddNewDynamicQuestionError = "ADD_NEW_DYNAMIC_QUESTION_ERROR";
export const SetDynamicQuestionAssignments = "SET_DYNAMIC_QUESTION_ASSIGNMENTS";
export const SetDynamicQuestionDraftAssignments = "SET_DYNAMIC_QUESTION_DRAFT_ASSIGNMENTS";
export const SetDynamicQuestionStatus = "SET_DYNAMIC_QUESTION_STATUS";
export const GetDynamicQuestion = "GET_DYNAMIC_QUESTION";
export const GetDynamicQuestionSuccess = "GET_DYNAMIC_QUESTION_SUCCESS";
export const GetDynamicQuestionError = "GET_DYNAMIC_QUESTION_ERROR";
export const ShowDynamicQuestionEditModal = "SHOW_DYNAMIC_QUESTION_EDIT_MODAL";
export const UpdateDynamicQuestion = "UPDATE_DYNAMIC_QUESTION";
export const UpdateDynamicQuestionSuccess = "UPDATE_DYNAMIC_QUESTION_SUCCESS";
export const UpdateDynamicQuestionError = "UPDATE_DYNAMIC_QUESTION_ERROR";
export const SetShowSubmitDynamicQuestionModal = "SET_SHOW_SUBMIT_DYNAMIC_QUESTION_MODAL";
export const SetShowCancelDynamicQuestionModal = "SET_SHOW_CANCEL_DYNAMIC_QUESTION_MODAL";
export const SubmitDynamicQuestionForReview = "SUBMIT_DYNAMIC_QUESTION_FOR_REVIEW";
export const SubmitDynamicQuestionForReviewSuccess = "SUBMIT_DYNAMIC_FOR_REVIEW_SUCCESS";
export const SubmitDynamicQuestionForReviewError = "SUBMIT_DYNAMIC_FOR_REVIEW_ERROR";
export const CancelDynamicQuestionReview = "CANCEL_DYNAMIC_QUESTION_REVIEW";
export const CancelDynamicQuestionReviewSuccess = "CANCEL_DYNAMIC_QUESTION_REVIEW_SUCCESS";
export const CancelDynamicQuestionReviewError = "CANCEL_DYNAMIC_QUESTION_REVIEW_ERROR";
export const StartDynamicQuestionDraft = "START_DYNAMIC_QUESTION_DRAFT";
export const StartDynamicQuestionDraftSuccess = "START_DYNAMIC_QUESTION_DRAFT_SUCCESS";
export const SetShowDiscardDynamicQuestionModal = "SET_SHOW_DISCARD_DYNAMIC_QUESTION_MODAL";
export const DiscardDynamicQuestionDraft = "DISCARD_DYNAMIC_QUESTION_DRAFT";
export const DiscardDynamicQuestionDraftSuccess = "DISCARD_DYNAMIC_QUESTION_DRAFT_SUCCESS";
export const SetShowCancelDiscardDynamicQuestionModal =
  "SET_SHOW_CANCEL_DISCARD_DYNAMIC_QUESTION_MODAL";
export const CancelDynamicQuestionReviewAndDiscard = "CANCEL_DYNAMIC_QUESTION_REVIEW_AND_DISCARD";
export const DuplicateDynamicQuestion = "DUPLICATE_DYNAMIC_QUESTION";
export const DuplicateDynamicQuestionSuccess = "DUPLICATE_DYNAMIC_QUESTION_SUCCESS";
export const SetShowDisableDynamicQuestionModal = "SET_SHOW_DISABLE_DYNAMIC_QUESTION_MODAL";
export const DisableDynamicQuestion = "DISBALE_DYNAMIC_QUESTION";
export const DisableDynamicQuestionSuccess = "DISBALE_DYNAMIC_QUESTION_SUCCESS";
export const StartDynamicQuestionDraftError = "START_DYNAMIC_QUESTION_DRAFT_ERROR";
export const DiscardDynamicQuestionDraftError = "DISCARD_DYNAMIC_QUESTION_DRAFT_ERROR";
export const DuplicateDynamicQuestionError = "DUPLICATE_DYNAMIC_QUESTION_ERROR";
export const CancelDynamicQuestionReviewAndDiscardError =
  "CANCEL_DYNAMIC_QUESTION_REVIEW_AND_DISCARD_ERROR";
export const DisableDynamicQuestionError = "DISABLE_DYNAMIC_QUESTION_ERROR";
export const UpdateDynamicQuestionAssignments = "UPDATE_DYNAMIC_QUESTION_ASSIGNMENTS";
export const UpdateDynamicQuestionAssignmentsError = "UPDATE_DYNAMIC_QUESTION_ASSIGNMENTS_ERROR";
export const ShowEditDynamicQuestionAssignmentsModal =
  "SHOW_EDIT_DYNAMIC_QUESTION_ASSIGNMENTS_MODAL";

// Default Standard Scripts
export const GetDefaultStandardScript = "GET_DEFAULT_STANDARD_SCRIPT";
export const GetDefaultStandardScriptSuccess = "GET_DEFAULT_STANDARD_SCRIPT_SUCCESS";
export const GetDefaultStandardScriptError = "GET_DEFAULT_STANDARD_SCRIPT_ERROR";
export const ToggleEditDefaultStandardScriptModal = "TOGGLE_EDIT_DEFAULT_STANDARD_SCRIPT_MODAL";
export const StartDefaultStandardScriptDraftSuccess = "START_DEFAULT_STANDARD_SCRIPT_DRAFT_SUCCESS";
export const UpdateDefaultStandardScript = "UPDATE_DEFAULT_STANDARD_SCRIPT";
export const UpdateDefaultStandardScriptSuccess = "UPDATE_DEFAULT_STANDARD_SCRIPT_SUCCESS";
export const UpdateDefaultStandardScriptError = "UPDATE_DEFAULT_STANDARD_SCRIPT_ERROR";
export const UpdateDefaultStandardScriptDraft = "UPDATE_DEFAULT_STANDARD_SCRIPT_DRAFT";
export const SetShowDisableDefaultStandardScriptModal =
  "SET_SHOW_DISABLE_DEFAULT_STANDARD_SCRIPT_MODAL";
export const DisableDefaultStandardScript = "DISABLE_DEFAULT_STANDARD_SCRIPT";
export const DiscardDefaultStandardScriptDraft = "DISCARD_DEFAULT_STANDARD_SCRIPT_DRAFT";
export const DiscardDefaultStandardScriptDraftSuccess =
  "DISCARD_DEFAULT_STANDARD_SCRIPT_DRAFT_SUCCESS";
export const SetShowDiscardDefaultStandardScriptModal =
  "SET_SHOW_DISCARD_DEFAULT_STANDARD_SCRIPT_MODAL";
export const SetShowCancelDefaultStandardScriptModal =
  "SET_SHOW_CANCEL_DEFAULT_STANDARD_SCRIPT_MODAL";
export const SetShowCancelDiscardDefaultStandardScriptModal =
  "SET_SHOW_CANCEL_DISCARD_DEFAULT_STANDARD_SCRIPT_MODAL";
export const SetShowSubmitDefaultStandardScriptModal =
  "SET_SHOW_SUBMIT_DEFAULT_STANDARD_SCRIPT_MODAL";
export const CancelDefaultStandardScriptReview = "CANCEL_DEFAULT_STANDARD_SCRIPT_REVIEW";
export const CancelDefaultStandardScriptReviewError = "CANCEL_DEFAULT_STANDARD_SCRIPT_REVIEW_ERROR";
export const CancelDefaultStandardScriptReviewSuccess =
  "CANCEL_DEFAULT_STANDARD_SCRIPT_REVIEW_SUCCESS";
export const CancelDefaultStandardScriptReviewAndDiscard =
  "CANCEL_DEFAULT_STANDARD_SCRIPT_REVIEW_AND_DISCARD";
export const CancelDefaultStandardScriptReviewAndDiscardSuccess =
  "CANCEL_DEFAULT_STANDARD_SCRIPT_REVIEW_AND_DISCARD_SUCCESS";
export const SubmitDefaultStandardScriptForReview = "SUBMIT_DEFAULT_STANDARD_SCRIPT_FOR_REVIEW";
export const SubmitDefaultStandardScriptForReviewSuccess =
  "SUBMIT_DEFAULT_STANDARD_SCRIPT_FOR_REVIEW_SUCCESS";
export const SubmitDefaultStandardScriptForReviewError =
  "SUBMIT_DEFAULT_STANDARD_SCRIPT_FOR_REVIEW_ERROR";
export const StartDefaultStandardScriptDraft = "START_DEFAULT_STANDARD_SCRIPT_DRAFT";
export const SetDefaultStandardScriptStatus = "SET_DEFAULT_STANDARD_SCRIPT_STATUS";

// Department Specific Scripts
export const GetDepartmentSpecificScripts = "GET_DEPARTMENT_SPECIFIC_SCRIPTS";
export const GetDepartmentSpecificScriptsSuccess = "GET_DEPARTMENT_SPECIFIC_SCRIPTS_SUCCESS";
export const GetDepartmentSpecificScriptsError = "GET_DEPARTMENT_SPECIFIC_SCRIPTS_ERROR";
export const NewDepartmentSpecificScript = "NEW_DEPARTMENT_SPECIFIC_SCRIPT";
export const NewDepartmentSpecificScriptAssignments = "NEW_DEPARTMENT_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const ShowAddDepartmentSpecificScriptModal = "SHOW_ADD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const SetDepartmentSpecificScriptRevisionSchema = "SET_DEPARTMENT_SPECIFIC_SCRIPT_SCHEMA";
export const SetShowSubmitDepartmentSpecificScriptModal =
  "SET_SHOW_SUBMIT_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const SubmitDepartmentSpecificScriptForReview =
  "SUBMIT_DEPARTMENT_SPECIFIC_SCRIPT_FOR_REVIEW";
export const SubmitDepartmentSpecificScriptForReviewSuccess =
  "SUBMIT_DEPARTMENT_SPECIFIC_SCRIPT_FOR_REVIEW_SUCCESS";
export const SubmitDepartmentSpecificScriptForReviewError =
  "SUBMIT_DEPARTMENT_SPECIFIC_SCRIPT_FOR_REVIEW_ERROR";
export const CancelDepartmentSpecificScriptReview = "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW";
export const CancelDepartmentSpecificScriptReviewSuccess =
  "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW_SUCCESS";
export const CancelDepartmentSpecificScriptReviewError =
  "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW_ERROR";
export const SetShowCancelDepartmentSpecificScriptModal =
  "SET_SHOW_CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const DiscardDepartmentSpecificScriptDraft = "DISCARD_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT";
export const DiscardDepartmentSpecificScriptDraftSuccess =
  "DISCARD_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT_SUCCESS";
export const DiscardDepartmentSpecificScriptDraftError =
  "DISCARD_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT_ERROR";
export const SetShowDiscardDepartmentSpecificScriptModal =
  "SET_SHOW_DISCARD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const SetShowCancelDiscardDepartmentSpecificScriptModal =
  "SET_SHOW_CANCEL_DISCARD_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const CancelDepartmentSpecificScriptReviewAndDiscard =
  "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD";
export const CancelDepartmentSpecificScriptReviewAndDiscardSuccess =
  "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD_SUCCESS";
export const CancelDepartmentSpecificScriptReviewAndDiscardError =
  "CANCEL_DEPARTMENT_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD_ERROR";
export const SetShowDisableDepartmentSpecificScriptModal =
  "SET_SHOW_DISABLE_DEPARTMENT_SPECIFIC_SCRIPT_MODAL";
export const DisableDepartmentSpecificScript = "DISABLE_DEPARTMENT_SPECIFIC_SCRIPT";
export const DisableDepartmentSpecificScriptSuccess = "DISABLE_DEPARTMENT_SPECIFIC_SCRIPT_SUCCESS";
export const DisableDepartmentSpecificScriptError = "DISABLE_DEPARTMENT_SPECIFIC_SCRIPT_ERROR";

export const UpdateDepartmentSpecificScriptDraft = "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT";
export const SetDepartmentSpecificScriptAssignments = "SET_DEPARTMENT_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const SetDepartmentSpecificScriptDraftAssignments =
  "SET_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT_ASSIGNMENTS";
export const AddDepartmentSpecificScript = "ADD_DEPARTMENT_SPECIFIC_SCRIPT";
export const AddDepartmentSpecificScriptSuccess = "ADD_DEPARTMENT_SPECIFIC_SCRIPT_SUCCESS";
export const AddDepartmentSpecificScriptError = "ADD_DEPARTMENT_SPECIFIC_SCRIPT_ERROR";
export const GetDepartmentSpecificScriptActiveSuccess =
  "GET_DEPARTMENT_SPECIFIC_SCRIPT_ACTIVE_SUCCESS";
export const GetDepartmentSpecificScriptActiveError = "GET_DEPARTMENT_SPECIFIC_SCRIPT_ACTIVE_ERROR";
export const GetDepartmentSpecificScript = "GET_DEPARTMENT_SPECIFIC_SCRIPT";
export const GetDepartmentSpecificScriptSuccess = "GET_DEPARTMENT_SPECIFIC_SCRIPT_SUCCESS";
export const GetDepartmentSpecificScriptError = "GET_DEPARTMENT_SPECIFIC_SCRIPT_ERROR";
export const ShowDepartmentSpecificScriptEditModal = "SHOW_DEPARTMENT_SPECIFIC_SCRIPT_EDIT_MODAL";
export const StartDepartmentSpecificScriptDraft = "START_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT";
export const StartDepartmentSpecificScriptDraftSuccess =
  "START_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT_SUCCESS";
export const StartDepartmentSpecificScriptDraftError =
  "START_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT_ERROR";
export const DuplicateDepartmentSpecificScript = "DUPLICATE_DEPARTMENT_SPECIFIC_SCRIPT";
export const DuplicateDepartmentSpecificScriptSuccess =
  "DUPLICATE_DEPARTMENT_SPECIFIC_SCRIPT_SUCCESS";
export const DuplicateDepartmentSpecificScriptError = "DUPLICATE_DEPARTMENT_SPECIFIC_SCRIPT_ERROR";
export const ShowEditDepartmentSpecificScriptAssignmentsModal =
  "SHOW_EDIT_DEPARTMENT_SPECIFIC_SCRIPT_ASSIGNMENTS_MODAL";
export const UpdateDepartmentSpecificScriptAssignments =
  "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const UpdateDepartmentSpecificScriptAssignmentsError =
  "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT_ASSIGNMENTS_ERROR";
export const UpdateDepartmentSpecificScript = "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT";
export const UpdateDepartmentSpecificScriptSuccess = "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT_SUCCESS";
export const UpdateDepartmentSpecificScriptError = "UPDATE_DEPARTMENT_SPECIFIC_SCRIPT_ERROR";
export const SetDepartmentSpecificScriptDraft = "SET_DEPARTMENT_SPECIFIC_SCRIPT_DRAFT";

// Reasons Specific Scripts
export const GetReasonSpecificScripts = "GET_REASON_SPECIFIC_SCRIPTS";
export const GetReasonSpecificScriptsSuccess = "GET_REASON_SPECIFIC_SCRIPTS_SUCCESS";
export const GetReasonSpecificScriptsError = "GET_REASON_SPECIFIC_SCRIPTS_ERROR";
export const NewReasonSpecificScript = "NEW_REASON_SPECIFIC_SCRIPT";
export const NewReasonSpecificScriptAssignments = "NEW_REASON_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const ShowAddReasonSpecificScriptModal = "SHOW_ADD_REASON_SPECIFIC_SCRIPT_MODAL";
export const SetReasonSpecificScriptRevisionSchema = "SET_REASON_SPECIFIC_SCRIPT_SCHEMA";
export const SetShowSubmitReasonSpecificScriptModal =
  "SET_SHOW_SUBMIT_REASON_SPECIFIC_SCRIPT_MODAL";
export const SubmitReasonSpecificScriptForReview = "SUBMIT_REASON_SPECIFIC_SCRIPT_FOR_REVIEW";
export const SubmitReasonSpecificScriptForReviewSuccess =
  "SUBMIT_REASON_SPECIFIC_SCRIPT_FOR_REVIEW_SUCCESS";
export const SubmitReasonSpecificScriptForReviewError =
  "SUBMIT_REASON_SPECIFIC_SCRIPT_FOR_REVIEW_ERROR";
export const CancelReasonSpecificScriptReview = "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW";
export const CancelReasonSpecificScriptReviewSuccess =
  "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW_SUCCESS";
export const CancelReasonSpecificScriptReviewError = "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW_ERROR";
export const SetShowCancelReasonSpecificScriptModal =
  "SET_SHOW_CANCEL_REASON_SPECIFIC_SCRIPT_MODAL";
export const DiscardReasonSpecificScriptDraft = "DISCARD_REASON_SPECIFIC_SCRIPT_DRAFT";
export const DiscardReasonSpecificScriptDraftSuccess =
  "DISCARD_REASON_SPECIFIC_SCRIPT_DRAFT_SUCCESS";
export const DiscardReasonSpecificScriptDraftError = "DISCARD_REASON_SPECIFIC_SCRIPT_DRAFT_ERROR";
export const SetShowDiscardReasonSpecificScriptModal =
  "SET_SHOW_DISCARD_REASON_SPECIFIC_SCRIPT_MODAL";
export const SetShowCancelDiscardReasonSpecificScriptModal =
  "SET_SHOW_CANCEL_DISCARD_REASON_SPECIFIC_SCRIPT_MODAL";
export const CancelReasonSpecificScriptReviewAndDiscard =
  "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD";
export const CancelReasonSpecificScriptReviewAndDiscardSuccess =
  "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD_SUCCESS";
export const CancelReasonSpecificScriptReviewAndDiscardError =
  "CANCEL_REASON_SPECIFIC_SCRIPT_REVIEW_AND_DISCARD_ERROR";
export const SetShowDisableReasonSpecificScriptModal =
  "SET_SHOW_DISABLE_REASON_SPECIFIC_SCRIPT_MODAL";
export const DisableReasonSpecificScript = "DISABLE_REASON_SPECIFIC_SCRIPT";
export const DisableReasonSpecificScriptSuccess = "DISABLE_REASON_SPECIFIC_SCRIPT_SUCCESS";
export const DisableReasonSpecificScriptError = "DISABLE_REASON_SPECIFIC_SCRIPT_ERROR";

export const UpdateReasonSpecificScriptDraft = "UPDATE_REASON_SPECIFIC_SCRIPT_DRAFT";
export const SetReasonSpecificScriptAssignments = "SET_REASON_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const SetReasonSpecificScriptDraftAssignments =
  "SET_REASON_SPECIFIC_SCRIPT_DRAFT_ASSIGNMENTS";
export const AddReasonSpecificScript = "ADD_REASON_SPECIFIC_SCRIPT";
export const AddReasonSpecificScriptError = "ADD_REASON_SPECIFIC_SCRIPT_ERROR";
export const GetReasonSpecificScriptActiveSuccess = "GET_REASON_SPECIFIC_SCRIPT_ACTIVE_SUCCESS";
export const GetReasonSpecificScript = "GET_REASON_SPECIFIC_SCRIPT";
export const GetReasonSpecificScriptSuccess = "GET_REASON_SPECIFIC_SCRIPT_SUCCESS";
export const GetReasonSpecificScriptError = "GET_REASON_SPECIFIC_SCRIPT_ERROR";
export const ShowReasonSpecificScriptEditModal = "SHOW_REASON_SPECIFIC_SCRIPT_EDIT_MODAL";
export const StartReasonSpecificScriptDraft = "START_REASON_SPECIFIC_SCRIPT_DRAFT";
export const StartReasonSpecificScriptDraftSuccess = "START_REASON_SPECIFIC_SCRIPT_DRAFT_SUCCESS";
export const StartReasonSpecificScriptDraftError = "START_REASON_SPECIFIC_SCRIPT_DRAFT_ERROR";
export const DuplicateReasonSpecificScript = "DUPLICATE_REASON_SPECIFIC_SCRIPT";
export const DuplicateReasonSpecificScriptSuccess = "DUPLICATE_REASON_SPECIFIC_SCRIPT_SUCCESS";
export const DuplicateReasonSpecificScriptError = "DUPLICATE_REASON_SPECIFIC_SCRIPT_ERROR";
export const ShowEditReasonSpecificScriptAssignmentsModal =
  "SHOW_EDIT_REASON_SPECIFIC_SCRIPT_ASSIGNMENTS_MODAL";
export const UpdateReasonSpecificScriptAssignments = "UPDATE_REASON_SPECIFIC_SCRIPT_ASSIGNMENTS";
export const UpdateReasonSpecificScriptAssignmentsError =
  "UPDATE_REASON_SPECIFIC_SCRIPT_ASSIGNMENTS_ERROR";
export const UpdateReasonSpecificScript = "UPDATE_REASON_SPECIFIC_SCRIPT";
export const UpdateReasonSpecificScriptSuccess = "UPDATE_REASON_SPECIFIC_SCRIPT_SUCCESS";
export const UpdateReasonSpecificScriptError = "UPDATE_REASON_SPECIFIC_SCRIPT_ERROR";
export const SetReasonSpecificScriptDraft = "SET_REASON_SPECIFIC_SCRIPT_DRAFT";

// Standard Questions
export const GetStandardQuestions = "GET_STANDARD_QUESTIONS";
export const GetStandardQuestionsSuccess = "GET_STANDARD_QUESTIONS_SUCCESS";
export const GetStandardQuestionsError = "GET_STANDARD_QUESTIONS_ERROR";
export const ShowAddStandardQuestionModal = "SHOW_ADD_STANDARD_QUESTION_MODAL";
export const NewStandardQuestion = "NEW_STANDARD_QUESTION";
export const UpdateStandardQuestionDraft = "UPDATE_STANDARD_QUESTION_DRAFT";
export const SetStandardQuestionRevisionSchema = "SET_STANDARD_QUESTION_REVISION_SCHEMA";
export const GetStandardQuestionActive = "GET_STANDARD_QUESTION_ACTIVE";
export const GetStandardQuestionActiveSuccess = "GET_STANDARD_QUESTION_ACTIVE_SUCCESS";
export const GetStandardQuestionActiveError = "GET_STANDARD_QUESTION_ACTIVE_ERROR";
export const AddNewStandardQuestion = "ADD_NEW_STANDARD_QUESTION";
export const AddNewStandardQuestionSuccess = "ADD_NEW_STANDARD_QUESTION_SUCCESS";
export const AddNewStandardQuestionError = "ADD_NEW_STANDARD_QUESTION_ERROR";
export const SetStandardQuestionAssignments = "SET_STANDARD_QUESTION_ASSIGNMENTS";
export const SetStandardQuestionDraftAssignments = "SET_STANDARD_QUESTION_DRAFT_ASSIGNMENTS";
export const SetStandardQuestionStatus = "SET_STANDARD_QUESTION_STATUS";
export const GetStandardQuestion = "GET_STANDARD_QUESTION";
export const GetStandardQuestionSuccess = "GET_STANDARD_QUESTION_SUCCESS";
export const GetStandardQuestionError = "GET_STANDARD_QUESTION_ERROR";
export const ShowStandardQuestionEditModal = "SHOW_STANDARD_QUESTION_EDIT_MODAL";
export const UpdateStandardQuestion = "UPDATE_STANDARD_QUESTION";
export const UpdateStandardQuestionSuccess = "UPDATE_STANDARD_QUESTION_SUCCESS";
export const UpdateStandardQuestionError = "UPDATE_STANDARD_QUESTION_ERROR";
export const SetShowSubmitStandardQuestionModal = "SET_SHOW_SUBMIT_STANDARD_QUESTION_MODAL";
export const SetShowCancelStandardQuestionModal = "SET_SHOW_CANCEL_STANDARD_QUESTION_MODAL";
export const SubmitStandardQuestionForReview = "SUBMIT_STANDARD_QUESTION_FOR_REVIEW";
export const SubmitStandardQuestionForReviewSuccess = "SUBMIT_STANDARD_FOR_REVIEW_SUCCESS";
export const SubmitStandardQuestionForReviewError = "SUBMIT_STANDARD_FOR_REVIEW_ERROR";
export const CancelStandardQuestionReview = "CANCEL_STANDARD_QUESTION_REVIEW";
export const CancelStandardQuestionReviewSuccess = "CANCEL_STANDARD_QUESTION_REVIEW_SUCCESS";
export const CancelStandardQuestionReviewError = "CANCEL_STANDARD_QUESTION_REVIEW_ERROR";
export const StartStandardQuestionDraft = "START_STANDARD_QUESTION_DRAFT";
export const StartStandardQuestionDraftSuccess = "START_STANDARD_QUESTION_DRAFT_SUCCESS";
export const SetShowDiscardStandardQuestionModal = "SET_SHOW_DISCARD_STANDARD_QUESTION_MODAL";
export const DiscardStandardQuestionDraft = "DISCARD_STANDARD_QUESTION_DRAFT";
export const DiscardStandardQuestionDraftSuccess = "DISCARD_STANDARD_QUESTION_DRAFT_SUCCESS";
export const SetShowCancelDiscardStandardQuestionModal =
  "SET_SHOW_CANCEL_DISCARD_STANDARD_QUESTION_MODAL";
export const CancelStandardQuestionReviewAndDiscard = "CANCEL_STANDARD_QUESTION_REVIEW_AND_DISCARD";
export const DuplicateStandardQuestion = "DUPLICATE_STANDARD_QUESTION";
export const DuplicateStandardQuestionSuccess = "DUPLICATE_STANDARD_QUESTION_SUCCESS";
export const SetShowDisableStandardQuestionModal = "SET_SHOW_DISABLE_STANDARD_QUESTION_MODAL";
export const DisableStandardQuestion = "DISBALE_STANDARD_QUESTION";
export const DisableStandardQuestionSuccess = "DISBALE_STANDARD_QUESTION_SUCCESS";
export const StartStandardQuestionDraftError = "START_STANDARD_QUESTION_DRAFT_ERROR";
export const DiscardStandardQuestionDraftError = "DISCARD_STANDARD_QUESTION_DRAFT_ERROR";
export const DuplicateStandardQuestionError = "DUPLICATE_STANDARD_QUESTION_ERROR";
export const CancelStandardQuestionReviewAndDiscardError =
  "CANCEL_STANDARD_QUESTION_REVIEW_AND_DISCARD_ERROR";
export const DisableStandardQuestionError = "DISABLE_STANDARD_QUESTION_ERROR";
export const UpdateStandardQuestionAssignments = "UPDATE_STANDARD_QUESTION_ASSIGNMENTS";
export const UpdateStandardQuestionAssignmentsError = "UPDATE_STANDARD_QUESTION_ASSIGNMENTS_ERROR";
export const ShowEditStandardQuestionAssignmentsModal =
  "SHOW_EDIT_STANDARD_QUESTION_ASSIGNMENTS_MODAL";

export const ToggleEmployeeUsersModal = "TOGGLE_EMPLOYEE_USERS_MODAL";
